import { Error } from "@progress/kendo-react-labels";
import { useEffect, useRef, useState } from "react";
import { SampleFileTemplate } from "./file-template/SampleFileTemplate";
import { TemplateFile2 } from "./file-template/templateFile2";



import { GHP_DrugMonitoringForm } from "./file-template/GHP_DrugMonitoringForm";
import { GHP_COREOrderForServicesMD } from "./file-template/GHP_COREOrderForServicesMD";
import { GHP_COREOrderForServices } from "./file-template/GHP_COREOrderForServices";
import { GHP_AIMS } from "./file-template/GHP_AIMS";
import { GHP_AIMS_V2 } from "./file-template/GHP_AIMS_V2";
import { GHP_CALOCUS_V1 } from "./file-template/GHP_CALOCUS_V1";
import { GHP_MedicationInformedConsentForm } from "./file-template/GHP_MedicationInformedConsentForm";
import { GHP_IFIBPS } from "./file-template/GHP_IFIBPS";
import { GHP_IFIDischargeSummary } from "./file-template/GHP_IFIDischargeSummary";
import { GHP_IFIOrderForServicesMedical } from "./file-template/GHP_IFIOrderForServicesMedical";
import { GHP_IFIOrderForServices } from "./file-template/GHP_IFIOrderForServices";
import { GHP_IFISafetyPlan } from "./file-template/GHP_IFISafetyPlan";
import { GHP_ISR } from "./file-template/GHP_ISR";
import { GHP_IndividualStatusReport } from "./file-template/GHP_IndividualStatusReport";
import { GHP_MARS } from "./file-template/GHP_MARS";
import { GHP_PhysicianFollowUp } from "./file-template/GHP_PhysicianFollowUp";
import { GHP_PsychiatricEvaluation } from "./file-template/GHP_PsychiatricEvaluation";
import { GHP_QuarterlyBehaviour } from "./file-template/GHP_QuarterlyBehaviour";
import { GHP_EarlyTermination } from "./file-template/GHP_EarlyTermination";
import { GHP_InformedConsentforMedication } from "./file-template/GHP_InformedConsentforMedication";
import { GHP_NewLocus } from "./file-template/GHP_NewLocus";
import { GHP_DischargeSummary } from "./file-template/GHP_DischargeSummary";
import { GHP_ANSA } from "./file-template/GHP_ANSA";
import { GHP_CANS } from "./file-template/GHP_CANS";
import { GHP_ClientIntroductionLetter } from "./file-template/GHP_ClientIntroductionLetter";
import { GHP_CourtReport } from "./file-template/GHP_CourtReport";
import { GHP_MedicationConsentChild } from "./file-template/GHP_MedicationConsentChild";
import { GHP_CALOCUS } from "./file-template/GHP_CALOCUS";
import { GHP_ChildAdultAssessment } from "./file-template/GHP_ChildAdultAssessment";
import { GHP_BlankOrderForServices } from "./file-template/GHP_BlankOrderForServices";
import { GHP_ChildAdolescentNeedStrengths } from "./file-template/GHP_ChildAdolescentNeedStrengths";
import { GHP_AdultAssessment } from "./file-template/GHP_AdultAssessment";
import { GHP_CriticalIncidentReport } from "./file-template/GHP_CriticalIncidentReport";
import { GHP_NursingAssessment } from "./file-template/GHP_NursingAssessment";
import { GHP_CaBiopsychosocialTreatmentPlan } from "./file-template/GHP_CaBiopsychosocialTreatmentPlan";
import { GHP_AdultBiopsychosocialTreatmentPlan } from "./file-template/GHP_AdultBiopsychosocialTreatmentPlan";
import { GHP_NursingFollowUpTemplate } from "./file-template/GHP_NursingFollowUpTemplate";
import { GHP_OldVersionNursingAssessment } from "./file-template/GHP_OldVersionNursingAssessment";
import { GHP_DiagnosticAssessment } from "./file-template/GHP_DiagnosticAssessment";
import { GHP_IfiTreatmentPlan } from "./file-template/GHP_IfiTreatmentPlan";

import { GENERAL_MonthlyStaffForm } from "./file-template/GENERAL_MonthlyStaffForm";
import { GENERAL_DischargeSummary } from "./file-template/GENERAL_DischargeSummary";
import { GENERAL_HealthReassessment } from "./file-template/GENERAL_HealthReassessment";
import { GENERAL_PsychiatricAssessment } from "./file-template/GENERAL_PsychiatricAssessment";
import { GENERAL_NursingAssessment } from "./file-template/GENERAL_NursingAssessment";
import { GENERAL_DiagnosticAssessment } from "./file-template/GENERAL_DiagnosticAssessment";
import { GENERAL_InformedConsentforMedication } from "./file-template/GENERAL_InformedConsentforMedication";
import { GENERAL_MedicationConsentChild } from "./file-template/GENERAL_MedicationConsentChild";
import { GENERAL_MedicationInformedConsentForm } from "./file-template/GENERAL_MedicationInformedConsentForm";
import { GENERAL_TeleBehavioralHealthInformedConsent } from "./file-template/GENERAL_TeleBehavioralHealthInformedConsent";
import { GENERAL_TreatmentPlanConsent } from "./file-template/GENERAL_TreatmentPlanConsent";
import { GENERAL_ConsentForTreatment } from "./file-template/GENERAL_ConsentForTreatment";
import { GENERAL_ConsentToTeleMentalHealth } from "./file-template/GENERAL_ConsentToTeleMentalHealth";
import { GENERAL_AdultIntake } from "./file-template/GENERAL_AdultIntake";
import { GENERAL_ChildIntake } from "./file-template/GENERAL_ChildIntake";
import { GENERAL_IntakeReferralForm } from "./file-template/GENERAL_IntakeReferralForm";
import { GENERAL_CssrsAssessment } from "./file-template/GENERAL_CssrsAssessment";
import { GENERAL_CANS } from "./file-template/GENERAL_CANS";
import { GENERAL_SNAP } from "./file-template/GENERAL_SNAP";
import { GENERAL_ANSA } from "./file-template/GENERAL_ANSA";
import { GENERAL_AIMS } from "./file-template/GENERAL_AIMS";
import { GENERAL_OrderOfServices } from "./file-template/GENERAL_OrderOfServices";
import { GENERAL_AuthorizationToRelease } from "./file-template/GENERAL_AuthorizationToRelease";
import { GENERAL_BehavioralHealthAssessment } from "./file-template/GENERAL_BehavioralHealthAssessment";
import { GENERAL_MedicaidAssessment } from "./file-template/GENERAL_MedicaidAssessment";
import { GENERAL_LOCUS } from "./file-template/GENERAL_LOCUS";
import { GENERAL_CALOCUS } from "./file-template/GENERAL_CALOCUS";
import { GENERAL_BiopsychosocialAdult } from "./file-template/GENERAL_BiopsychosocialAdult";
import { GENERAL_BiopsychosocialChild } from "./file-template/GENERAL_BiopsychosocialChild";
import { GENERAL_Bps } from "./file-template/GENERAL_Bps";
import { GENERAL_ReferralAndIntake } from "./file-template/GENERAL_ReferralAndIntake";
import { GENERAL_FamilyNeedsAssessment } from "./file-template/GENERAL_FamilyNeedsAssessment";
import { GENERAL_MigrantInformationForm } from "./file-template/GENERAL_MigrantInformationForm";
import { GENERAL_ServicePlan } from "./file-template/GENERAL_ServicePlan";
import { GENERAL_ServicePlanConsent } from "./file-template/GENERAL_ServicePlanConsent";
import { GENERAL_FollowUpForm } from "./file-template/GENERAL_FollowUpForm";
import { GENERAL_FollowUpDocumentation } from "./file-template/GENERAL_FollowUpDocumentation";
import { GENERAL_ProgressNotes } from "./file-template/GENERAL_ProgressNotes";
import { GENERAL_ReferralForm } from "./file-template/GENERAL_ReferralForm";
import { GENERAL_CaseClosureForm } from "./file-template/GENERAL_CaseClosureForm";
import { GENERAL_CaseTransfer } from "./file-template/GENERAL_CaseTransfer";
import { GENERAL_SignificantProviderChanges } from "./file-template/GENERAL_SignificantProviderChanges";
import { GENERAL_RecordOfBilledServices } from "./file-template/GENERAL_RecordOfBilledServices";
import { GENERAL_EngAuthorizationToDPHI } from "./file-template/GENERAL_EngAuthorizationToDPHI";
import { GENERAL_SpanishAuthorizationToDPHI } from "./file-template/GENERAL_SpanishAuthorizationToDPHI";
import { GENERAL_ProviderSystemsReview } from "./file-template/GENERAL_ProviderSystemsReview";
import { GENERAL_RecordReviewToolForProviders } from "./file-template/GENERAL_RecordReviewToolForProviders";
import { GENERAL_PhysicalHealthStandard } from "./file-template/GENERAL_PhysicalHealthStandard";
import { GENERAL_MentalHealthRehabilitationAdult } from "./file-template/GENERAL_MentalHealthRehabilitationAdult";
import { GENERAL_BehavioralHealthOutpatient } from "./file-template/GENERAL_BehavioralHealthOutpatient";
import { GENERAL_BehavioralHealthCommunity } from "./file-template/GENERAL_BehavioralHealthCommunity";
import { GENERAL_OutpatientTreatmentRequest } from "./file-template/GENERAL_OutpatientTreatmentRequest";
import { GENERAL_Asam } from "./file-template/GENERAL_Asam";
import { GENERAL_PCP } from "./file-template/GENERAL_PCP";
import { GENERAL_PIE } from "./file-template/GENERAL_PIE";

import { LaGeneral_AdultAssessment1915 } from "./file-template/LaGeneral_AdultAssessment1915";
import { LaGeneral_PsychiatricAssessment } from "./file-template/LaGeneral_PsychiatricAssessment";
import { LaGeneral_YouthAssessment1915 } from "./file-template/LaGeneral_YouthAssessment1915";
import { LaGeneral_SafetyPlan } from "./file-template/LaGeneral_SafetyPlan";
import { LaGeneral_StrengthAndNeeds } from "./file-template/LaGeneral_StrengthAndNeeds";
import { LaGeneral_HealthAndWellnessQuestionnaire } from "./file-template/LaGeneral_HealthAndWellnessQuestionnaire";
import { LaGeneral_AdultMentalHealthRehabilitationTreatmentRequestForm } from "./file-template/LaGeneral_AdultMentalHealthRehabilitationTreatmentRequestForm";
import { LaGeneral_AetnaBetterHealthOfLouisiana } from "./file-template/LaGeneral_AetnaBetterHealthOfLouisiana";
import { LaGeneral_AmerigroupOutpatientTreatmentRequestForm } from "./file-template/LaGeneral_AmerigroupOutpatientTreatmentRequestForm";
import { LaGeneral_ChildAndAdolescentMentalHealthRehabilitationTreatmentRequestForm } from "./file-template/LaGeneral_ChildAndAdolescentMentalHealthRehabilitationTreatmentRequestForm";
import { LaGeneral_Asam } from "./file-template/LaGeneral_Asam";
import { LaGeneral_BehaviorModificationPlan } from "./file-template/LaGeneral_BehaviorModificationPlan";
import { LaGeneral_IBHA1915c } from "./file-template/LaGeneral_IBHA1915c";
import { LaGeneral_CalocusScoresheet } from "./file-template/LaGeneral_CalocusScoresheet";
import { LaGeneral_Cans } from "./file-template/LaGeneral_Cans";
import { LaGeneral_CommunityBasedServicesAuthorizationRequestForm } from "./file-template/LaGeneral_CommunityBasedServicesAuthorizationRequestForm";
import { LaGeneral_CrisisPlan } from "./file-template/LaGeneral_CrisisPlan";
import { LaGeneral_InitialCrisisIntervention } from "./file-template/LaGeneral_InitialCrisisIntervention";
import { LaGeneral_OutpatientTreatmentRequestForm } from "./file-template/LaGeneral_OutpatientTreatmentRequestForm";
import { LaGeneral_LOCUS } from "./file-template/LaGeneral_LOCUS";
import { LaGeneral_LocusScoringSheet } from "./file-template/LaGeneral_LocusScoringSheet";
import { LaGeneral_OutpatientTreatmentRequest } from "./file-template/LaGeneral_OutpatientTreatmentRequest";
import { LaGeneral_RequestForm } from "./file-template/LaGeneral_RequestForm";
import { LaGeneral_ProgressNote } from "./file-template/LaGeneral_ProgressNote";
import { LaGeneral_RehabilitationMemberChoiceForm } from "./file-template/LaGeneral_RehabilitationMemberChoiceForm";
import { LaGeneral_TeleHealthConsentForm } from "./file-template/LaGeneral_TeleHealthConsentForm";
import { LaGeneral_WellnessAssessmentYouth } from "./file-template/LaGeneral_WellnessAssessmentYouth";
import { LaGeneral_AHCHealthAndWellnessQuestionnaire } from "./file-template/LaGeneral_AHCHealthAndWellnessQuestionnaire";
import { LaGeneral_BHBHA } from "./file-template/LaGeneral_BHBHA";
import { LaGeneral_WellnessAssessmentAdult } from "./file-template/LaGeneral_WellnessAssessmentAdult";

import { TxGeneral_CANS } from "./file-template/TxGeneral_CANS";
import { TxGeneral_CansChild6 } from "./file-template/TxGeneral_CansChild6";
import { TxGeneral_CansChild3 } from "./file-template/TxGeneral_CansChild3";
import { TxGeneral_ANSA } from "./file-template/TxGeneral_ANSA";

import { NcGeneral_ComprehensiveClinicalAssessment } from "./file-template/NcGeneral_ComprehensiveClinicalAssessment";
import { NcGeneral_CCA } from "./file-template/NcGeneral_CCA";


import { GaGeneral_BiopsychosocialAdult } from "./file-template/GaGeneral_BiopsychosocialAdult";
import { GaGeneral_BiopsychosocialChild } from "./file-template/GaGeneral_BiopsychosocialChild";


import { AI_BIRP } from "./file-template/AI_BIRP";

import { NBT_AdultIntake } from "./file-template/NBT_AdultIntake";
import { NBT_ChildIntake } from "./file-template/NBT_ChildIntake";
import { NBT_AngerAdultAssessment } from "./file-template/NBT_AngerAdultAssessment";
import { NBT_AnxietyAdult } from "./file-template/NBT_AnxietyAdult";
import { NBT_6MonthReassessment } from "./file-template/NBT_6MonthReassessment";
import { NBT_ClientReport } from "./file-template/NBT_ClientReport";
import { NBT_CrisisPlan } from "./file-template/NBT_CrisisPlan";
import { NBT_CrossCuttingSymptomMeasure } from "./file-template/NBT_CrossCuttingSymptomMeasure";
import { NBT_DiagnosticExam } from "./file-template/NBT_DiagnosticExam";
import { NBT_DepressionAdult } from "./file-template/NBT_DepressionAdult";
import { NBT_DischargeSummary } from "./file-template/NBT_DischargeSummary";
import { NBT_ParentGuardian } from "./file-template/NBT_ParentGuardian";
import { NBT_ManiaAdult } from "./file-template/NBT_ManiaAdult";
import { NBT_NurseAssessment } from "./file-template/NBT_NurseAssessment";
import { NBT_OrderOfServices } from "./file-template/NBT_OrderOfServices";
import { NBT_SubstanceUseAdult } from "./file-template/NBT_SubstanceUseAdult";
import { NBT_ThoughtsAdult } from "./file-template/NBT_ThoughtsAdult";
import { NBT_PsychFollowUp } from "./file-template/NBT_PsychFollowUp";
import { NBT_PsychDiagnosticExam } from "./file-template/NBT_PsychDiagnosticExam";
import { NBT_SomaticSymptomAdultPatient } from "./file-template/NBT_SomaticSymptomAdultPatient";
import { NBT_BiopsychosocialChild } from "./file-template/NBT_BiopsychosocialChild";
import { NBT_BiopsychosocialAdult } from "./file-template/NBT_BiopsychosocialAdult";
import { NBT_Assessment } from "./file-template/NBT_Assessment";
import { NBT_AssessmentV2 } from "./file-template/NBT_AssessmentV2";
import { NBT_SchoolConsultationForm } from "./file-template/NBT_SchoolConsultationForm";
import { NBT_CssrsScreenerLifetime } from "./file-template/NBT_CssrsScreenerLifetime";
import { NBT_CssrsScreenerFollowUp } from "./file-template/NBT_CssrsScreenerFollowUp";
import { NBT_ReleaseOfInformation } from "./file-template/NBT_ReleaseOfInformation";
import { NBT_SchoolConsentForm } from "./file-template/NBT_SchoolConsentForm";

import { ROC_IntakeReferralForm } from "./file-template/ROC_IntakeReferralForm";
import { ROC_MemberOrientationForm } from "./file-template/ROC_MemberOrientationForm";
import { ROC_RecipientRightsResponsibilities } from "./file-template/ROC_RecipientRightsResponsibilities";
import { ROC_ReleaseOfInformation } from "./file-template/ROC_ReleaseOfInformation";
import { ROC_TeleBehavioralHealthInformedConsent } from "./file-template/ROC_TeleBehavioralHealthInformedConsent";
import { ROC_EmergencyMedicalTreatment } from "./file-template/ROC_EmergencyMedicalTreatment";
import { ROC_ClientConfidentiality } from "./file-template/ROC_ClientConfidentiality";
import { ROC_AuthorizationReleaseOfInformation } from "./file-template/ROC_AuthorizationReleaseOfInformation";
import { ROC_GrievanceProcedure } from "./file-template/ROC_GrievanceProcedure";
import { ROC_PermissionToBill } from "./file-template/ROC_PermissionToBill";
import { ROC_ClientWaiver } from "./file-template/ROC_ClientWaiver";
import { ROC_ProviderSelection } from "./file-template/ROC_ProviderSelection";
import { ROC_NoticeOfPrivacyPractices } from "./file-template/ROC_NoticeOfPrivacyPractices";
import { ROC_TreatmentPlanConsent } from "./file-template/ROC_TreatmentPlanConsent";
import { ROC_DiagnosticAssessment } from "./file-template/ROC_DiagnosticAssessment";
import { ROC_MemberSatisfactionSurvey } from "./file-template/ROC_MemberSatisfactionSurvey";
import { ROC_ProfessionalDevelopment } from "./file-template/ROC_ProfessionalDevelopment";
import { GENERAL_StaffPlanDocument } from "./file-template/GENERAL_StaffPlanDocument";
import { ROC_SupervisionForm } from "./file-template/ROC_SupervisionForm";
import { ROC_CriticalIncidentReportForm } from "./file-template/ROC_CriticalIncidentReportForm";


import { ROCLA_BhaAdult } from "./file-template/ROCLA_BhaAdult";
import { ROCLA_BhaChild } from "./file-template/ROCLA_BhaChild";

import { NP_UnitReq } from "./file-template/NP_UnitRequest";
import { NP_DischargeSummary } from "./file-template/NP_DischargeSummary";
import { NP_MonthlySummary } from "./file-template/NP_MonthlySummary";
import { NP_DiagnosticAssessment } from "./file-template/NP_DiagnosticAssessment";
import { NP_AdultBha } from "./file-template/NP_AdultBha";
import { NP_SubstanceAbuseAssesment } from "./file-template/NP_SubstanceAbuseAssesment";
import { NP_NursingAssessment } from "./file-template/NP_NursingAssessment";
import { NP_CaAssessment } from "./file-template/NP_CaAssessment";
import { NP_PsychMed } from "./file-template/NP_PsychMed";
import { LSS_AAsamAssessment } from "./file-template/LSS_AAsamAssessment";
import { LSS_DiagnosticEvaluation } from "./file-template/LSS_DiagnosticEvaluation";
import { LSS_CaAsamAssessment } from "./file-template/LSS_CaAsamAssessment";
import { LSS_SudItp } from "./file-template/LSS_SudItp";
import { LSS_IntegratedBehavioralHealth } from "./file-template/LSS_IntegratedBehavioralHealth";
import { LSS_IndividualTreatmentPlan } from "./file-template/LSS_IndividualTreatmentPlan";
import { LSS_OrderOfServices } from "./file-template/LSS_OrderOfServices";
import { LSS_TerminationLetter } from "./file-template/LSS_TerminationLetter";
import { LSS_DischargeSummary } from "./file-template/LSS_DischargeSummary";
import { LSS_IndividualStatusReport } from "./file-template/LSS_IndividualStatusReport";
import { LSS_ClientDischargeSummary } from "./file-template/LSS_ClientDischargeSummary";
import { LSS_StatementOfProviderChoice } from "./file-template/LSS_StatementOfProviderChoice";
import { LSS_ConsumerRights } from "./file-template/LSS_ConsumerRights";
import { LSS_PatientFinancialResponsibility } from "./file-template/LSS_PatientFinancialResponsibility";
import { LSS_AuthorizationToRelease } from "./file-template/LSS_AuthorizationToRelease";
import { LSS_ConsentForTreatment } from "./file-template/LSS_ConsentForTreatment";
import { LSS_PhotoReleaseForm } from "./file-template/LSS_PhotoReleaseForm";
import { LSS_ConsentToTeleMentalHealth } from "./file-template/LSS_ConsentToTeleMentalHealth";
import { LSS_TransportationPermissionSlip } from "./file-template/LSS_TransportationPermissionSlip";


import { AJC_AttendancePolicyConsent } from "./file-template/AJC_AttendancePolicyConsent";
import { AJC_AuthorizationReleaseInformation } from "./file-template/AJC_AuthorizationReleaseInformation";
import { AJC_ClientGrievances } from "./file-template/AJC_ClientGrievances";
import { AJC_ClientRightsResponsibilities } from "./file-template/AJC_ClientRightsResponsibilities";
import { AJC_ConsentForServices } from "./file-template/AJC_ConsentForServices";
import { AJC_DemographicForm } from "./file-template/AJC_DemographicForm";
import { AJC_NoticeOfPrivacyPractice } from "./file-template/AJC_NoticeOfPrivacyPractice";
import { AJC_SrcTransportationServices } from "./file-template/AJC_SrcTransportationServices";
import { AJC_IntakeForm } from "./file-template/AJC_IntakeForm";
import { AJC_ChildIntakeQuestionnaire } from "./file-template/AJC_ChildIntakeQuestionnaire";
import { ATC_AngerAdultAssessment } from "./file-template/ATC_AngerAdultAssessment";
import { ATC_AnxietyAdult } from "./file-template/ATC_AnxietyAdult";
import { ATC_BehaviorAndSymptomRatingScale } from "./file-template/ATC_BehaviorAndSymptomRatingScale";
import { ATC_CommunityResourceLinkage } from "./file-template/ATC_CommunityResourceLinkage";
import { ATC_FollowUpProgressNote } from "./file-template/ATC_FollowUpProgressNote";
import { ATC_PatientConsentForm } from "./file-template/ATC_PatientConsentForm";
import { ATC_InitialDiagnosticProgressNote } from "./file-template/ATC_InitialDiagnosticProgressNote";
import { ATC_BpsAdult } from "./file-template/ATC_BpsAdult";
import { ATC_BpsChild } from "./file-template/ATC_BpsChild";
import { ATC_CssrsScreenerClinical } from "./file-template/ATC_CssrsScreenerClinical";
import { ATC_MonthlyServiceSummary } from "./file-template/ATC_MonthlyServiceSummary";
import { ATC_NurseAx } from "./file-template/ATC_NurseAx";
import { ATC_NurseFu } from "./file-template/ATC_NurseFu";
import { ATC_ANSA } from "./file-template/ATC_ANSA";
import { ATC_CANS } from "./file-template/ATC_CANS";
import { ATC_CssrsScreenerLifetimeRecent } from "./file-template/ATC_CssrsScreenerLifetimeRecent";
import { ATC_DischargeSummary } from "./file-template/ATC_DischargeSummary";
import { ATC_OrderOfServices } from "./file-template/ATC_OrderOfServices";
import { ATC_Wellcare } from "./file-template/ATC_Wellcare";
import { ATC_SubstanceAbuseChild } from "./file-template/ATC_SubstanceAbuseChild";
import { ATC_SubstanceAbuseAdult } from "./file-template/ATC_SubstanceAbuseAdult";
import { ATC_SomaticSymptomPatient } from "./file-template/ATC_SomaticSymptomPatient";

import { CS_InterviewQuestions } from "./file-template/CS_InterviewQuestions";
import { CS_ReleaseOfInformation } from "./file-template/CS_ReleaseOfInformation";
import { CS_Disclosure } from "./file-template/CS_Disclosure";
import { CS_AdditionalInformation } from "./file-template/CS_AdditionalInformation";
import { CS_ProgressReport } from "./file-template/CS_ProgressReport";
import { CS_JobTrackingSheet } from "./file-template/CS_JobTrackingSheet";

import { GFIT_AmazingPediatricsReferralForm } from "./file-template/GFIT_AmazingPediatricsReferralForm";
import { GFIT_AuthorizationConsent } from "./file-template/GFIT_AuthorizationConsent";
import { GFIT_FollowUpNursingAssessment } from "./file-template/GFIT_FollowUpNursingAssessment";
import { GFIT_InitialNursingAssessment } from "./file-template/GFIT_InitialNursingAssessment";
import { GFIT_LaboratoryRequestForm } from "./file-template/GFIT_LaboratoryRequestForm";
import { GFIT_PsychiatricEM } from "./file-template/GFIT_PsychiatricEM";
import { GFIT_PsychiatricEvaluationTemplate } from "./file-template/GFIT_PsychiatricEvaluationTemplate";
import { GFIT_PsychotropicMedConsent } from "./file-template/GFIT_PsychotropicMedConsent";
import { GFIT_AdultAdhd } from "./file-template/GFIT_AdultAdhd";
import { GFIT_AdultServiceOrder } from "./file-template/GFIT_AdultServiceOrder";
import { GFIT_ChildAdhd } from "./file-template/GFIT_ChildAdhd";
import { GFIT_CssrsForm } from "./file-template/GFIT_CssrsForm";
import { GFIT_VerifiedDiagnosisForm } from "./file-template/GFIT_VerifiedDiagnosisForm";
import { GFIT_AdultPtsdForm } from "./file-template/GFIT_AdultPtsdForm";
import { GFIT_SafetyPlan } from "./file-template/GFIT_SafetyPlan";

import { JHC_AdolescentIntakePacket } from "./file-template/JHC_AdolescentIntakePacket";
import { JHC_AdultIntakePacket } from "./file-template/JHC_AdultIntakePacket";
import { JHC_AdultAcknowledementOfClientHandbook } from "./file-template/JHC_AdultAcknowledementOfClientHandbook";
import { JHC_AdultClientAbuse } from "./file-template/JHC_AdultClientAbuse";
import { JHC_AdultClientFreedomChoice } from "./file-template/JHC_AdultClientFreedomChoice";
import { JHC_AdultClientGrievances } from "./file-template/JHC_AdultClientGrievances";
import { JHC_AdultClientOrientation } from "./file-template/JHC_AdultClientOrientation";
import { JHC_AdultClientRightsAndResponsbilities } from "./file-template/JHC_AdultClientRightsAndResponsbilities";
import { JHC_AdultCrisisMangeGuidelines } from "./file-template/JHC_AdultCrisisMangeGuidelines";
import { JHC_AdultDeterminationProcess } from "./file-template/JHC_AdultDeterminationProcess";
import { JHC_AdultEmergencyPreparednessQuestionnaire } from "./file-template/JHC_AdultEmergencyPreparednessQuestionnaire";
import { JHC_AdultHippaAcknowledement } from "./file-template/JHC_AdultHippaAcknowledement";
import { JHC_AdultHippaAuthForm } from "./file-template/JHC_AdultHippaAuthForm";
import { JHC_AdultInformedConsentforTreatment } from "./file-template/JHC_AdultInformedConsentforTreatment";
import { JHC_AdultPhq } from "./file-template/JHC_AdultPhq";
import { JHC_AdultPsychiatricAdvanceDirective } from "./file-template/JHC_AdultPsychiatricAdvanceDirective";
import { JHC_AdultTeleMedicineService } from "./file-template/JHC_AdultTeleMedicineService";
import { JHC_InSchoolSetting } from "./file-template/JHC_InSchoolSetting";

import { FWC_BhaAdult } from "./file-template/FWC_BhaAdult";
import { FWC_BhaChild } from "./file-template/FWC_BhaChild";
import { FWC_ClientLegalForm } from "./file-template/FWC_ClientLegalForm";
import { FWC_ServicePlanDevelopment } from "./file-template/FWC_ServicePlanDevelopment";

import { SSS_MentalHealthAdult } from "./file-template/SSS_MentalHealthAdult";
import { SSS_MentalHealthChild } from "./file-template/SSS_MentalHealthChild";
import { SSS_ProgressSummary } from "./file-template/SSS_ProgressSummary";
import { SSS_PsychiatricEvaluation } from "./file-template/SSS_PsychiatricEvaluation";
import { SSS_PsychiatricFollowUp } from "./file-template/SSS_PsychiatricFollowUp";
import { SSS_TreatmentPlanReview } from "./file-template/SSS_TreatmentPlanReview";

import { EDU_TCMNeedsAssessment } from "./file-template/EDU_TCMNeedsAssessment";
import { EDU_NoteRiskAssessment } from "./file-template/EDU_NoteRiskAssessment";
import { EDU_MonthlyClinicalSummary } from "./file-template/EDU_MonthlyClinicalSummary";
import { EDU_HealthReassessment } from "./file-template/EDU_HealthReassessment";
import { EDU_Bps } from "./file-template/EDU_Bps";
import { EDU_Biospsychosocial } from "./file-template/EDU_Biospsychosocial";
import { EDU_UniversalNote } from "./file-template/EDU_UniversalNote";
import { EDU_CANS } from "./file-template/EDU_CANS";

import { LCS_YouthAssessment1915 } from "./file-template/LCS_YouthAssessment1915";
import { LCS_InitialCaseSummary } from "./file-template/LCS_InitialCaseSummary";
import { LCS_AdultAssessment1915 } from "./file-template/LCS_AdultAssessment1915";
import { LCS_CrisisSafetyPlan } from "./file-template/LCS_CrisisSafetyPlan";
import { LCS_FreedomOfChoice } from "./file-template/LCS_FreedomOfChoice";
import { LCS_RehabMemberChoice } from "./file-template/LCS_RehabMemberChoice";
import { LCS_ProgressSummary2023 } from "./file-template/LCS_ProgressSummary2023";
import { LCS_WeeklyCaseSummary } from "./file-template/LCS_WeeklyCaseSummary";
import { LCS_MstDischargeSummary } from "./file-template/LCS_MstDischargeSummary";
import { LCS_DischargeSummary } from "./file-template/LCS_DischargeSummary";
import { LCS_TransitionPlan } from "./file-template/LCS_TransitionPlan";
import { LCS_PsychiatricAssessment } from "./file-template/LCS_PsychiatricAssessment";
import { LCS_Calocus } from "./file-template/LCS_Calocus";
import { LCS_Locus } from "./file-template/LCS_Locus";
import { LCS_CrisisIntakeAssessment } from "./file-template/LCS_CrisisIntakeAssessment";
import { LCS_IndividualClinicalSupervision } from "./file-template/LCS_IndividualClinicalSupervision";

import { FYD_ChildAssessment } from "./file-template/FYD_ChildAssessment";

import { RNFI_ClientRights } from "./file-template/RNFI_ClientRights";
import { RNFI_ConsentToTreatment } from "./file-template/RNFI_ConsentToTreatment";
import { RNFI_Hippa } from "./file-template/RNFI_Hippa";
import { RNFI_LabConsent } from "./file-template/RNFI_LabConsent";
import { RNFI_LimitsToLiability } from "./file-template/RNFI_LimitsToLiability";
import { RNFI_PersonalHxForm } from "./file-template/RNFI_PersonalHxForm";
import { RNFI_PlanSignaturePage } from "./file-template/RNFI_PlanSignaturePage";
import { RNFI_Roi } from "./file-template/RNFI_Roi";
import { RNFI_TransportationWaiver } from "./file-template/RNFI_TransportationWaiver";
import { RNFI_Assessment } from "./file-template/RNFI_Assessment";
import { RNFI_BiopsychosocialAdult } from "./file-template/RNFI_BiopsychosocialAdult";
import { RNFI_BiopsychosocialChild } from "./file-template/RNFI_BiopsychosocialChild";
import { RNFI_CssrsLifetimeRecent } from "./file-template/RNFI_CssrsLifetimeRecent";
import { RNFI_CssrsLifetimeRecentYoungChild } from "./file-template/RNFI_CssrsLifetimeRecentYoungChild";
import { RNFI_DiagnosticAx } from "./file-template/RNFI_DiagnosticAx";
import { RNFI_DischargeSummary } from "./file-template/RNFI_DischargeSummary";
import { RNFI_CmoAuthorizationRequestForm } from "./file-template/RNFI_CmoAuthorizationRequestForm";


import { JCS_BhaChild } from "./file-template/JCS_BhaChild";
import { JCS_BhaAdult } from "./file-template/JCS_BhaAdult";

import { RHCA_IntakePacket } from "./file-template/RHCA_IntakePacket";
import { RHCA_ReleaseOfInformation } from "./file-template/RHCA_ReleaseOfInformation";
import { RHCA_SafetyPlan } from "./file-template/RHCA_SafetyPlan";
import { RHCA_OrderForServices } from "./file-template/RHCA_OrderForServices";
import { RHCA_ChildAndAdolescentBha } from "./file-template/RHCA_ChildAndAdolescentBha";
import { RHCA_ANSA } from "./file-template/RHCA_ANSA";

import { MRRC_PhysicalHealthStandard } from "./file-template/MRRC_PhysicalHealthStandard";
import { MRRC_MentalHealthRehabilitationAdult } from "./file-template/MRRC_MentalHealthRehabilitationAdult";
import { MRRC_BehavioralHealthOutpatient } from "./file-template/MRRC_BehavioralHealthOutpatient";
import { MRRC_BehavioralHealthCommunity } from "./file-template/MRRC_BehavioralHealthCommunity";
import { MRRC_OutpatientTreatmentRequest } from "./file-template/MRRC_OutpatientTreatmentRequest";
import { MRRC_MemberChoiceForm } from "./file-template/MRRC_MemberChoiceForm";

import { MC_ComprehensiveClinicalAssessment } from "./file-template/MC_ComprehensiveClinicalAssessment";
import { MC_IntakeAssessment } from "./file-template/MC_IntakeAssessment";


import { OABS_AdultSubstanceAssessment } from "./file-template/OABS_AdultSubstanceAssessment";
import { OABS_Asam } from "./file-template/OABS_Asam";
import { OABS_ChildSubstanceAssessment } from "./file-template/OABS_ChildSubstanceAssessment";
import { OABS_PsychiatricEvaluation } from "./file-template/OABS_PsychiatricEvaluation";
import { OABS_BhaChild } from "./file-template/OABS_BhaChild";
import { OABS_BhaAdult } from "./file-template/OABS_BhaAdult";
import { OABS_AnnualPsychiatric } from "./file-template/OABS_AnnualPsychiatric";


import { PD_DischargeSummary } from "./file-template/PD_DischargeSummary";
import { PD_BehavioralHealthAssessment } from "./file-template/PD_BehavioralHealthAssessment";
import { PD_AnnualPacket } from "./file-template/PD_AnnualPacket";
import { PD_IntakePacket } from "./file-template/PD_IntakePacket";

import { LHH_WeeklyProgressNote } from "./file-template/LHH_WeeklyProgressNote";
import { LHH_IddServiceNote } from "./file-template/LHH_IddServiceNote";
import { LHH_ConsumerReferralForm } from "./file-template/LHH_ConsumerReferralForm";
import { LHH_InitialAssessment } from "./file-template/LHH_InitialAssessment";
import { LHH_OutPatientTreatmentRequest } from "./file-template/LHH_OutPatientTreatmentRequest";
import { LHH_SelfAdministeredMedObservation } from "./file-template/LHH_SelfAdministeredMedObservation";
import { LHH_IncidentReport } from "./file-template/LHH_IncidentReport";
import { LHH_ServiceTerminationChangeSummary } from "./file-template/LHH_ServiceTerminationChangeSummary";
import { LHH_ProviderDischargeSummary } from "./file-template/LHH_ProviderDischargeSummary";
import { LHH_DLAFunctionalAssessment } from "./file-template/LHH_DLAFunctionalAssessment";

import { LHH_24HrCrisisAndEmergencyAfterHr } from "./file-template/LHH_24HrCrisisAndEmergencyAfterHr";
import { LHH_AbuseAndNeglect } from "./file-template/LHH_AbuseAndNeglect";
import { LHH_AcknowledgementFreedomChoice } from "./file-template/LHH_AcknowledgementFreedomChoice";
import { LHH_AcknowledgementGrievanceProcedures } from "./file-template/LHH_AcknowledgementGrievanceProcedures";
import { LHH_BehaviorDataSheet } from "./file-template/LHH_BehaviorDataSheet";
import { LHH_ChiefComplaintReasonEncounter } from "./file-template/LHH_ChiefComplaintReasonEncounter";
import { LHH_ClientEntryForm } from "./file-template/LHH_ClientEntryForm";
import { LHH_ClientRights } from "./file-template/LHH_ClientRights";
import { LHH_ConfidentialityComplianceAgrmt } from "./file-template/LHH_ConfidentialityComplianceAgrmt";
import { LHH_ConsentReceiveServices } from "./file-template/LHH_ConsentReceiveServices";
import { LHH_ConsentReleaseInfo } from "./file-template/LHH_ConsentReleaseInfo";
import { LHH_DocOfHealthcareProviderVisits } from "./file-template/LHH_DocOfHealthcareProviderVisits";
import { LHH_ErPreparednessPlanAndAcknowledge } from "./file-template/LHH_ErPreparednessPlanAndAcknowledge";
import { LHH_FoodAllergiesForm } from "./file-template/LHH_FoodAllergiesForm";
import { LHH_IddActivitySuppPlan } from "./file-template/LHH_IddActivitySuppPlan";
import { LHH_IdDdWaiverBehaviorSuppPlan } from "./file-template/LHH_IdDdWaiverBehaviorSuppPlan";
import { LHH_IdDdWaiverBhSupportQuarterlyRevRep } from "./file-template/LHH_IdDdWaiverBhSupportQuarterlyRevRep";
import { LHH_IdDdWaiverFunctionalBhAss } from "./file-template/LHH_IdDdWaiverFunctionalBhAss";
import { LHH_IdDdWaiverJustificationForBhSuppSvs } from "./file-template/LHH_IdDdWaiverJustificationForBhSuppSvs";
import { LHH_IdDdWaiverReqForAdditionalBhSuppSvs } from "./file-template/LHH_IdDdWaiverReqForAdditionalBhSuppSvs";
import { LHH_IndividualSvsPlan } from "./file-template/LHH_IndividualSvsPlan";
import { LHH_LegalGuardianshipAssignBenefits } from "./file-template/LHH_LegalGuardianshipAssignBenefits";
import { LHH_LunchConsumptionChart } from "./file-template/LHH_LunchConsumptionChart";
import { LHH_MealChart } from "./file-template/LHH_MealChart";
import { LHH_MedicalExamination } from "./file-template/LHH_MedicalExamination";
import { LHH_MedicationEmerContactInfo } from "./file-template/LHH_MedicationEmerContactInfo";
import { LHH_PeriodicStaffingRevOfIsp } from "./file-template/LHH_PeriodicStaffingRevOfIsp";
import { LHH_PermissionToTransport } from "./file-template/LHH_PermissionToTransport";
import { LHH_PetPolicy } from "./file-template/LHH_PetPolicy";
import { LHH_PreliminaryPersonCenteredRecoveryPlan } from "./file-template/LHH_PreliminaryPersonCenteredRecoveryPlan";
import { LHH_PsychiatricAdvanceDirective } from "./file-template/LHH_PsychiatricAdvanceDirective";
import { LHH_PsychiatricAssessment } from "./file-template/LHH_PsychiatricAssessment";
import { LHH_PsychosocialAssessment } from "./file-template/LHH_PsychosocialAssessment";
import { LHH_QuarterlyHomeVisits } from "./file-template/LHH_QuarterlyHomeVisits";
import { LHH_RecoverySuppPlan2023 } from "./file-template/LHH_RecoverySuppPlan2023";
import { LHH_RightsIndividualsReceivingSvs } from "./file-template/LHH_RightsIndividualsReceivingSvs";
import { LHH_SymptomScreeningChecklist } from "./file-template/LHH_SymptomScreeningChecklist";
import { LHH_TelephoneVisitationAgreement } from "./file-template/LHH_TelephoneVisitationAgreement";
import { LHH_TerminationChangeSummary } from "./file-template/LHH_TerminationChangeSummary";
import { LHH_TraumaHistory } from "./file-template/LHH_TraumaHistory";
import { LHH_WaiverOfLiability } from "./file-template/LHH_WaiverOfLiability";
import { LHH_SelfAdminMedObservationLog } from "./file-template/LHH_SelfAdminMedObservationLog";
import { LHH_DailyLivingActivities } from "./file-template/LHH_DailyLivingActivities";
import { LHH_InitialAssessmentV2 } from "./file-template/LHH_InitialAssessmentV2";

import { BFCS_ClinicalSupervision } from "./file-template/BFCS_ClinicalSupervision";
import { BFCS_Locus } from "./file-template/BFCS_Locus";
import { BFCS_Calocus } from "./file-template/BFCS_Calocus";
import { BFCS_PsychiatricAssessment } from "./file-template/BFCS_PsychiatricAssessment";
import { BFCS_YouthAssessment1915 } from "./file-template/BFCS_YouthAssessment1915";
import { BFCS_CrisisSafetyPlan } from "./file-template/BFCS_CrisisSafetyPlan";
import { BFCS_DischargeSummary } from "./file-template/BFCS_DischargeSummary";
import { BFCS_InitialCaseSummary } from "./file-template/BFCS_InitialCaseSummary";
import { BFCS_MstDischargeSummary } from "./file-template/BFCS_MstDischargeSummary";
import { BFCS_ProgressSummary2023 } from "./file-template/BFCS_ProgressSummary2023";
import { BFCS_TransitionPlan } from "./file-template/BFCS_TransitionPlan";
import { BFCS_AdultAssessment1915 } from "./file-template/BFCS_AdultAssessment1915";
import { BFCS_FreedomOfChoice } from "./file-template/BFCS_FreedomOfChoice";
import { BFCS_RehabMemberChoice } from "./file-template/BFCS_RehabMemberChoice";
import { BFCS_WeeklyCaseSummary } from "./file-template/BFCS_WeeklyCaseSummary";
import { BFCS_CrisisIntakeAssessment } from "./file-template/BFCS_CrisisIntakeAssessment";

import { MMBHC_MentalHealthAssessment } from "./file-template/MMBHC_MentalHealthAssessment";
import { MMBHC_BehavioralHealthAssessment } from "./file-template/MMBHC_BehavioralHealthAssessment";
import { MMBHC_RecipientDataPacket } from "./file-template/MMBHC_RecipientDataPacket";

import { CBHS_RehabFormAdult } from "./file-template/CBHS_RehabFormAdult";
import { CBHS_RehabFormChild } from "./file-template/CBHS_RehabFormChild";
import { CBHS_PriorAuthorizationFormAethna } from "./file-template/CBHS_PriorAuthorizationFormAethna";
import { CBHS_BehavHealthOutTreatRequest } from "./file-template/CBHS_BehavHealthOutTreatRequest";
import { CBHS_AuthReferralRequestFormHumana } from "./file-template/CBHS_AuthReferralRequestFormHumana";

import { AA_BhaChild } from "./file-template/AA_BhaChild";
import { AA_BhaAdult } from "./file-template/AA_BhaAdult";


import { C3_BiopsychosocialAssessment } from "./file-template/C3_BiopsychosocialAssessment";
import { C3_DischargeSummary } from "./file-template/C3_DischargeSummary";
import { C3_AssessmentAddendum } from "./file-template/C3_AssessmentAddendum";
import { C3_CollaborativeTeamMeeting } from "./file-template/C3_CollaborativeTeamMeeting";
import { C3_PersonCenteredPlan } from "./file-template/C3_PersonCenteredPlan";
import { C3_Dla } from "./file-template/C3_Dla";

import { CBS_FaxCoverSheetAethna } from "./file-template/CBS_FaxCoverSheetAethna";
import { CBS_FaxCoverSheetAmerihealth } from "./file-template/CBS_FaxCoverSheetAmerihealth";
import { CBS_FaxCoverSheetHealthyBlue } from "./file-template/CBS_FaxCoverSheetHealthyBlue";
import { CBS_FaxCoverSheetLAHC } from "./file-template/CBS_FaxCoverSheetLAHC";
import { CBS_FaxCoverSheetUnitedHealthcare } from "./file-template/CBS_FaxCoverSheetUnitedHealthcare";
import { CBS_UnitedHealthcareAuthForm } from "./file-template/CBS_UnitedHealthcareAuthForm";
import { CBS_PriorAuthorizationFormAethna } from "./file-template/CBS_PriorAuthorizationFormAethna";
import { CBS_MentalHealthRehabilitationAdult } from "./file-template/CBS_MentalHealthRehabilitationAdult";
import { CBS_BehavHealthOutTreatRequest } from "./file-template/CBS_BehavHealthOutTreatRequest";
import { CBS_AuthReferralRequestFormHumana } from "./file-template/CBS_AuthReferralRequestFormHumana";
import { CBS_AdultAssessment1915i } from "./file-template/CBS_AdultAssessment1915i";
import { CBS_InitialPsychiatricAssessment } from "./file-template/CBS_InitialPsychiatricAssessment";
import { CBS_LhccOtr } from "./file-template/CBS_LhccOtr";
import { CBS_LocusScoreSheet } from "./file-template/CBS_LocusScoreSheet";
import { CBS_NpRequestedForm } from "./file-template/CBS_NpRequestedForm";

import { GBHCT_BpsDocument } from "./file-template/GBHCT_BpsDocument";

import { TCDC_HealthAssessmentAdult } from "./file-template/TCDC_HealthAssessmentAdult";
import { TCDC_HealthAssessmentYouth } from "./file-template/TCDC_HealthAssessmentYouth";

import { NHBC_ConsentForm } from "./file-template/NHBC_ConsentForm";
import { NHBC_BriefPsychosocialAssessment } from "./file-template/NHBC_BriefPsychosocialAssessment";
import { NHBC_ClientHandbook } from "./file-template/NHBC_ClientHandbook";
import { NHBC_CoreOrderForServices } from "./file-template/NHBC_CoreOrderForServices";
import { NHBC_CssrsScreenerClinical } from "./file-template/NHBC_CssrsScreenerClinical";
import { NHBC_CssrsScreenerLifetimeRecent } from "./file-template/NHBC_CssrsScreenerLifetimeRecent";
import { NHBC_CssrsPediaCogniImpaired } from "./file-template/NHBC_CssrsPediaCogniImpaired";
import { NHBC_DiagnosticAssessment } from "./file-template/NHBC_DiagnosticAssessment";
import { NHBC_DiagnosticOrderForServices } from "./file-template/NHBC_DiagnosticOrderForServices";
import { NHBC_DischargeSummary } from "./file-template/NHBC_DischargeSummary";
import { NHBC_DomesticViolenceAssessment } from "./file-template/NHBC_DomesticViolenceAssessment";
import { NHBC_BlankIntakeForm } from "./file-template/NHBC_BlankIntakeForm";
import { NHBC_Mdt } from "./file-template/NHBC_Mdt";
import { NHBC_NursingFollowUp } from "./file-template/NHBC_NursingFollowUp";
import { NHBC_NursingAssessmentInitial } from "./file-template/NHBC_NursingAssessmentInitial";
import { NHBC_PatientPortalConsentForm } from "./file-template/NHBC_PatientPortalConsentForm";
import { NHBC_PsychEvalFollowUp } from "./file-template/NHBC_PsychEvalFollowUp";
import { NHBC_PsychIntake } from "./file-template/NHBC_PsychIntake";
import { NHBC_PsychologicalTesingOrderForServices } from "./file-template/NHBC_PsychologicalTesingOrderForServices";
import { NHBC_PsychosocialAssessment } from "./file-template/NHBC_PsychosocialAssessment";
import { NHBC_ReleaseOfInformationForm } from "./file-template/NHBC_ReleaseOfInformationForm";
import { NHBC_SafetyPlan } from "./file-template/NHBC_SafetyPlan";
import { NHBC_SubstanceAbuseAssessment } from "./file-template/NHBC_SubstanceAbuseAssessment";
import { NHBC_TraumaAssessment } from "./file-template/NHBC_TraumaAssessment";

import { LBS_AdultIntake } from "./file-template/LBS_AdultIntake";
import { LBS_BriefBipolardisorderSymptomScale } from "./file-template/LBS_BriefBipolardisorderSymptomScale";
import { LBS_MedManagementPsychiatricProgressNote } from "./file-template/LBS_MedManagementPsychiatricProgressNote";
import { LBS_PsychiatricEvaluation } from "./file-template/LBS_PsychiatricEvaluation";
import { LBS_SafetyPlan } from "./file-template/LBS_SafetyPlan";
import { LBS_ScreenforChildAnxietyRelatedDisordersScaredChild } from "./file-template/LBS_ScreenforChildAnxietyRelatedDisordersScaredChild";
import { LBS_SnapAssessmentAdult } from "./file-template/LBS_SnapAssessmentAdult";
import { LBS_SnapAssessmentChildrenAdolescent } from "./file-template/LBS_SnapAssessmentChildrenAdolescent";
import { LBS_TreatmentPlanUpdateQuestionnaire } from "./file-template/LBS_TreatmentPlanUpdateQuestionnaire";
import { LBS_YouthIntake } from "./file-template/LBS_YouthIntake";
import { LBS_CuttingSymptomMeasureAdult } from "./file-template/LBS_CuttingSymptomMeasureAdult";
import { LBS_CuttingSymptomMeasureChild } from "./file-template/LBS_CuttingSymptomMeasureChild";
import { LBS_Gad } from "./file-template/LBS_Gad";
import { LBS_AngerChild } from "./file-template/LBS_AngerChild";
import { LBS_DepressionChild } from "./file-template/LBS_DepressionChild";

import { RRTS_Cans } from "./file-template/RRTS_Cans";
import { RRTS_RiskAndSubstanceAssessment } from "./file-template/RRTS_RiskAndSubstanceAssessment";
import { RRTS_RecipientSafetyPlan } from "./file-template/RRTS_RecipientSafetyPlan";
import { RRTS_IndividualizedCrisisPlan } from "./file-template/RRTS_IndividualizedCrisisPlan";
import { RRTS_BhaHumana } from "./file-template/RRTS_BhaHumana";
import { RRTS_BhaChild } from "./file-template/RRTS_BhaChild";
import { RRTS_BhaAdult } from "./file-template/RRTS_BhaAdult";
import { RRTS_OutpatientTreatmentRequest } from "./file-template/RRTS_OutpatientTreatmentRequest";
import { RRTS_monthlyStaffForm } from "./file-template/RRTS_monthlyStaffForm";
import { RRTS_ColumbiaRatingScaleandAssessment } from "./file-template/RRTS_ColumbiaRatingScaleandAssessment";
import { RRTS_DischargeSummary } from "./file-template/RRTS_DischargeSummary";
import { RRTS_HealthWellnessQuestionnaire } from "./file-template/RRTS_HealthWellnessQuestionnaire";
import { RRTS_AuthRequestHealthyBlueOPForm } from "./file-template/RRTS_AuthRequestHealthyBlueOPForm";
import { RRTS_AuthRequestAmerihealthAdult } from "./file-template/RRTS_AuthRequestAmerihealthAdult";
import { RRTS_AuthRequestAmerihealthChildOTRForm } from "./file-template/RRTS_AuthRequestAmerihealthChildOTRForm";
import { RRTS_AetnaPriorAuthrorization } from "./file-template/RRTS_AetnaPriorAuthrorization";

import { ACTS_AmethystTreatmentConsent } from "./file-template/ACTS_AmethystTreatmentConsent";
import { ACTS_BlankSed } from "./file-template/ACTS_BlankSed";
import { ACTS_CalocusScoringSheet } from "./file-template/ACTS_CalocusScoringSheet";
import { ACTS_CaregiverScreening } from "./file-template/ACTS_CaregiverScreening";
import { ACTS_Cats } from "./file-template/ACTS_Cats";
import { ACTS_Cft } from "./file-template/ACTS_Cft";
import { ACTS_ChildBehaviorChecklist } from "./file-template/ACTS_ChildBehaviorChecklist";
import { ACTS_ClientAcknowledgementsAdditionalConsents } from "./file-template/ACTS_ClientAcknowledgementsAdditionalConsents";
import { ACTS_ClinicalAssessmentSignaturePage } from "./file-template/ACTS_ClinicalAssessmentSignaturePage";
import { ACTS_ComprehensiveClinicalAssessment } from "./file-template/ACTS_ComprehensiveClinicalAssessment";
import { ACTS_ConsentMstServices } from "./file-template/ACTS_ConsentMstServices";
import { ACTS_DataSheet } from "./file-template/ACTS_DataSheet";
import { ACTS_DjjConsentForm } from "./file-template/ACTS_DjjConsentForm";
import { ACTS_FinancialResponsibilityAgreementAuthorization } from "./file-template/ACTS_FinancialResponsibilityAgreementAuthorization";
import { ACTS_InsuranceConsentFormReleaseInformation } from "./file-template/ACTS_InsuranceConsentFormReleaseInformation";
import { ACTS_IntakePacket } from "./file-template/ACTS_IntakePacket";
import { ACTS_JJBHConsentFormReleaseInformation } from "./file-template/ACTS_JJBHConsentFormReleaseInformation";
import { ACTS_LocoParents } from "./file-template/ACTS_LocoParents";
import { ACTS_MSTCaseSummary } from "./file-template/ACTS_MSTCaseSummary";
import { ACTS_MSTTreatmentPlanSignaturePage } from "./file-template/ACTS_MSTTreatmentPlanSignaturePage";
import { ACTS_Mass } from "./file-template/ACTS_Mass";
import { ACTS_MedicaidDirectTransition } from "./file-template/ACTS_MedicaidDirectTransition";
import { ACTS_MstGenogram } from "./file-template/ACTS_MstGenogram";
import { ACTS_MstPrescreening } from "./file-template/ACTS_MstPrescreening";
import { ACTS_MstProgram } from "./file-template/ACTS_MstProgram";
import { ACTS_MultisystemicTherapyPreScreening } from "./file-template/ACTS_MultisystemicTherapyPreScreening";
import { ACTS_NcSedCheckList } from "./file-template/ACTS_NcSedCheckList";
import { ACTS_OptDischargeSummary } from "./file-template/ACTS_OptDischargeSummary";
import { ACTS_OptProgram } from "./file-template/ACTS_OptProgram";
import { ACTS_OptTreatmentPlanSignaturePage } from "./file-template/ACTS_OptTreatmentPlanSignaturePage";
import { ACTS_OptTxPlan } from "./file-template/ACTS_OptTxPlan";
import { ACTS_OptTxPlanSig } from "./file-template/ACTS_OptTxPlanSig";
import { ACTS_PersonCenteredProfile } from "./file-template/ACTS_PersonCenteredProfile";
import { ACTS_PrimaryCareConsentFormReleaseInformation } from "./file-template/ACTS_PrimaryCareConsentFormReleaseInformation";
import { ACTS_SchoolConsentForm } from "./file-template/ACTS_SchoolConsentForm";
import { ACTS_SpecimenCollectionDrugTestingConsentForm } from "./file-template/ACTS_SpecimenCollectionDrugTestingConsentForm";
import { ACTS_SupervisionSign } from "./file-template/ACTS_SupervisionSign";
import { ACTS_WeeklyTelephoneConsultation } from "./file-template/ACTS_WeeklyTelephoneConsultation";
import { ACTS_YouthCatsScreening } from "./file-template/ACTS_YouthCatsScreening";
import { ACTS_BlankPersonCenteredPlan } from "./file-template/ACTS_BlankPersonCenteredPlan";

import { PBS_AdultAssessment } from "./file-template/PBS_AdultAssessment";
import { PBS_ChildAdolescentDiagnostic } from "./file-template/PBS_ChildAdolescentDiagnostic";
import { PBS_ChildAdolescentAssessment } from "./file-template/PBS_ChildAdolescentAssessment";

import { SLBC_Pcp } from "./file-template/SLBC_Pcp";

import { NWBH_FarsForm } from "./file-template/NWBH_FarsForm";
import { NWBH_ChildrenCfarsForm } from "./file-template/NWBH_ChildrenCfarsForm";
import { NWBH_ClientRegistration } from "./file-template/NWBH_ClientRegistration";
import { NWBH_flAdvDirectivesAdult } from "./file-template/NWBH_flAdvDirectivesAdult";
import { NWBH_NoticePrivacyPractices } from "./file-template/NWBH_NoticePrivacyPractices";
import { NWBH_flMHTCMChild } from "./file-template/NWBH_flMHTCMChild";
import { NWBH_flMHTCMAdult } from "./file-template/NWBH_flMHTCMAdult";
import { NWBH_flAnnualPsychosocialHistory } from "./file-template/NWBH_flAnnualPsychosocialHistory";
import { NWBH_ConsentForTreatment } from "./file-template/NWBH_ConsentForTreatment";
import { NWBH_BPSAdult } from "./file-template/NWBH_BPSAdult";
import { NWBH_BPSChild } from "./file-template/NWBH_BPSChild";
import { NWBH_BriefBehavioralHealth } from "./file-template/NWBH_BriefBehavioralHealth";
import { NWBH_ClientSafetyPlan } from "./file-template/NWBH_ClientSafetyPlan";
import { NWBH_ConsentofRelease } from "./file-template/NWBH_ConsentofRelease";
import { NWBH_PsychosocialTreatmentPlan } from "./file-template/NWBH_PsychosocialTreatmentPlan";
import { NWBH_MasterTreatmentPlan } from "./file-template/NWBH_MasterTreatmentPlan";
import { NWBH_MasterServicePlan } from "./file-template/NWBH_MasterServicePlan";
import { NWBH_flSchoolAuthorization } from "./file-template/NWBH_flSchoolAuthorization";
import { NWBH_ServicePlanReview6MoAdult } from "./file-template/NWBH_ServicePlanReview6MoAdult";
import { NWBH_Pcp } from "./file-template/NWBH_Pcp";
import { NWBH_AdmissionCriteria } from "./file-template/NWBH_AdmissionCriteria";
import { NWBH_AdultOutpatient } from "./file-template/NWBH_AdultOutpatient";
import { NWBH_ContinuedStayCriteria } from "./file-template/NWBH_ContinuedStayCriteria";
import { NWBH_InitialTreatmentPlan } from "./file-template/NWBH_InitialTreatmentPlan";
import { NWBH_Discharge } from "./file-template/NWBH_Discharge";
import { NWBH_FinancialAgreement } from "./file-template/NWBH_FinancialAgreement";
import { NWBH_ScreeningQuestionnaire } from "./file-template/NWBH_ScreeningQuestionnaire";
import { NWBH_SubstanceAbuseAdmission } from "./file-template/NWBH_SubstanceAbuseAdmission";
import { NWBH_SubstanceAbuseDischarge } from "./file-template/NWBH_SubstanceAbuseDischarge";
import { NWBH_SlidingFeeScale } from "./file-template/NWBH_SlidingFeeScale";
import { NWBH_OutcomeMeasures } from "./file-template/NWBH_OutcomeMeasures";

import { RPBS_FlAnnualPsychosocialHistory } from "./file-template/RPBS_FlAnnualPsychosocialHistory";
import { RPBS_AdvDirectivesAdult } from "./file-template/RPBS_AdvDirectivesAdult";
import { RPBS_FlBpsAnnual } from "./file-template/RPBS_FlBpsAnnual";
import { RPBS_FlBpsAdult } from "./file-template/RPBS_FlBpsAdult";
import { RPBS_MasterServicePlanAdult } from "./file-template/RPBS_MasterServicePlanAdult";
import { RPBS_MasterServicePlanChild } from "./file-template/RPBS_MasterServicePlanChild";
import { RPBS_MhtcmAdult } from "./file-template/RPBS_MhtcmAdult";
import { RPBS_MhtcmChild } from "./file-template/RPBS_MhtcmChild";
import { RPBS_ServicePlanSixMoChild } from "./file-template/RPBS_ServicePlanSixMoChild";
import { RPBS_ServicePlanAdult } from "./file-template/RPBS_ServicePlanAdult";
import { RPBS_ServicePlanAddendumChild } from "./file-template/RPBS_ServicePlanAddendumChild";
import { RPBS_ServicePlanReviewSixMoAdult } from "./file-template/RPBS_ServicePlanReviewSixMoAdult";
import { RPBS_MasterServicePlan } from "./file-template/RPBS_MasterServicePlan";
import { RPBS_AnnualPsychosocialHistory } from "./file-template/RPBS_AnnualPsychosocialHistory";
import { RPBS_ClientCfars } from "./file-template/RPBS_ClientCfars";
import { RPBS_ClientFarsForms } from "./file-template/RPBS_ClientFarsForms";
import { RPBS_ClientTransfer } from "./file-template/RPBS_ClientTransfer";
import { RPBS_DischargeSummary } from "./file-template/RPBS_DischargeSummary";
import { RPBS_GuardianshipCustodyAssessment } from "./file-template/RPBS_GuardianshipCustodyAssessment";
import { RPBS_ArPrivacyPracticesNotice } from "./file-template/RPBS_ArPrivacyPracticesNotice";
import { RPBS_BpsAdult } from "./file-template/RPBS_BpsAdult";
import { RPBS_BpsChild } from "./file-template/RPBS_BpsChild";
import { RPBS_BpsAnnual } from "./file-template/RPBS_BpsAnnual";
import { RPBS_BreakInService } from "./file-template/RPBS_BreakInService";
import { RPBS_BriefStatusExam } from "./file-template/RPBS_BriefStatusExam";
import { RPBS_CcbhProviderChoiceLetter } from "./file-template/RPBS_CcbhProviderChoiceLetter";
import { RPBS_ClientConsentForm } from "./file-template/RPBS_ClientConsentForm";
import { RPBS_ProceduresAcknowledgement } from "./file-template/RPBS_ProceduresAcknowledgement";
import { RPBS_ClientSignatureConfirmationSheet } from "./file-template/RPBS_ClientSignatureConfirmationSheet";
import { RPBS_SuicideRiskAssessment } from "./file-template/RPBS_SuicideRiskAssessment";
import { RPBS_TherapeuticBehavioralOnsiteServices } from "./file-template/RPBS_TherapeuticBehavioralOnsiteServices";
import { RPBS_TxPlanReview } from "./file-template/RPBS_TxPlanReview";
import { RPBS_PrivateHealthInformation } from "./file-template/RPBS_PrivateHealthInformation";
import { RPBS_ConsentForFollow } from "./file-template/RPBS_ConsentForFollow";
import { RPBS_ConsentForTreatment } from "./file-template/RPBS_ConsentForTreatment";
import { RPBS_TcmAssessmentChild } from "./file-template/RPBS_TcmAssessmentChild";
import { RPBS_SafetyPlan } from "./file-template/RPBS_SafetyPlan";
import { RPBS_TelemedicineConsent } from "./file-template/RPBS_TelemedicineConsent";
import { RPBS_AdvDirectivesChild } from "./file-template/RPBS_AdvDirectivesChild";
import { RPBS_Pcp } from "./file-template/RPBS_Pcp";
import { RPBS_SchoolAuthorization } from "./file-template/RPBS_SchoolAuthorization";

import { SBM_InitialPsychiatricEvaluation } from "./file-template/SBM_InitialPsychiatricEvaluation";

import { AFHS_InsyncIntakeQuestions } from "./file-template/AFHS_InsyncIntakeQuestions";
import { AFHS_ClinicalSupervisionParaprofessionals } from "./file-template/AFHS_ClinicalSupervisionParaprofessionals";
import { AFHS_ClinicalSupervision } from "./file-template/AFHS_ClinicalSupervision";
import { AFHS_OrderOfServices } from "./file-template/AFHS_OrderOfServices";
import { AFHS_Phq } from "./file-template/AFHS_Phq";
import { AFHS_Tsq } from "./file-template/AFHS_Tsq";
import { AFHS_MedicalConsent } from "./file-template/AFHS_MedicalConsent";
import { AFHS_Aims } from "./file-template/AFHS_Aims";
import { AFHS_AdhdTestAdult } from "./file-template/AFHS_AdhdTestAdult";
import { AFHS_BorderLinePersonalityDisorder } from "./file-template/AFHS_BorderLinePersonalityDisorder";
import { AFHS_OcdTest } from "./file-template/AFHS_OcdTest";
import { AFHS_PtsdScreening } from "./file-template/AFHS_PtsdScreening";
import { AFHS_ShortDepressionTest } from "./file-template/AFHS_ShortDepressionTest";
import { AFHS_SocialAnxietyPhobiaTest } from "./file-template/AFHS_SocialAnxietyPhobiaTest";
import { AFHS_OnlineBipolarTest } from "./file-template/AFHS_OnlineBipolarTest";
import { AFHS_TelemedicineTelephonicPacket } from "./file-template/AFHS_TelemedicineTelephonicPacket";
import { AFHS_IncidentReport } from "./file-template/AFHS_IncidentReport";
import { AFHS_ContractorTimeOffNotice } from "./file-template/AFHS_ContractorTimeOffNotice";
import { AFHS_CommunityServicelog } from "./file-template/AFHS_CommunityServicelog";
import { AFHS_EmployeeInformation } from "./file-template/AFHS_EmployeeInformation";
import { AFHS_EmployeeHandbook } from "./file-template/AFHS_EmployeeHandbook";
import { AFHS_OpenNoteneticRequest } from "./file-template/AFHS_OpenNoteneticRequest";
import { AFHS_TimeOffRequestForm } from "./file-template/AFHS_TimeOffRequestForm";
import { AFHS_GammisAuthReqAmerigroup } from "./file-template/AFHS_GammisAuthReqAmerigroup";
import { AFHS_GammisAuthReqCareSource } from "./file-template/AFHS_GammisAuthReqCareSource";
import { AFHS_GammisAuthReqMedicaid } from "./file-template/AFHS_GammisAuthReqMedicaid";
import { AFHS_GammisAuthReqPeachstate } from "./file-template/AFHS_GammisAuthReqPeachstate";
import { AFHS_GammisAuthReqPrivateOther } from "./file-template/AFHS_GammisAuthReqPrivateOther";
import { AFHS_WholeHealthWellnessSurvey } from "./file-template/AFHS_WholeHealthWellnessSurvey";



import { ACS_DischargeSummary } from "./file-template/ACS_DischargeSummary";
import { ACS_Biopsychosocial } from "./file-template/ACS_Biopsychosocial";
import { ACS_FollowUp } from "./file-template/ACS_FollowUp";
import { ACS_InitialIntakeNote } from "./file-template/ACS_InitialIntakeNote";
import { ACS_LifetimeRecentClinical } from "./file-template/ACS_LifetimeRecentClinical";
import { ACS_PediatricCognitivelyImpairedLifetime } from "./file-template/ACS_PediatricCognitivelyImpairedLifetime";
import { ACS_SinceLastVisitClinical } from "./file-template/ACS_SinceLastVisitClinical";
import { ACS_SuicideSafetyPlanIntervention } from "./file-template/ACS_SuicideSafetyPlanIntervention";
import { ACS_CANS } from "./file-template/ACS_CANS";
import { ACS_SupervisionForm } from "./file-template/ACS_SupervisionForm";
import { ACS_CssrsForm } from "./file-template/ACS_CssrsForm";
import { ACS_CtOrderForServices } from "./file-template/ACS_CtOrderForServices";
import { ACS_DocOrderForServices } from "./file-template/ACS_DocOrderForServices";


import { FHH_ClinicalSupervisionForm } from "./file-template/FHH_ClinicalSupervisionForm";


import { onShowFileTempFields } from "./file-template-utility";
import { useDispatch } from "react-redux";
import { loaderAction } from "src/redux/actions";
import { KMS_PsychEval } from "./file-template/KMS_PsychEval";
import { KMS_FollowUp } from "./file-template/KMS_FollowUp";

import { BTCS_ReleaseOfInformation } from "./file-template/BTCS_ReleaseOfInformation";
import { BTCS_CrisisPlan } from "./file-template/BTCS_CrisisPlan";
import { BTCS_ClientIncidentReport } from "./file-template/BTCS_ClientIncidentReport";
import { BTCS_DischargeSummary } from "./file-template/BTCS_DischargeSummary";
import { BTCS_DiagnosticAssessment } from "./file-template/BTCS_DiagnosticAssessment";

import { WFS_CssrsFullLifetime } from "./file-template/WFS_CssrsFullLifetime";
import { WFS_NeedsAndStrengths } from "./file-template/WFS_NeedsAndStrengths";

import { ACTG_PsychiatricEvaluation } from "./file-template/ACTG_PsychiatricEvaluation";
import { ACTG_BlankNcCca } from "./file-template/ACTG_BlankNcCca";

import { KE_SubstanceAbuse } from "./file-template/KE_SubstanceAbuse";
import { KE_KingdomExpressionsDischarge } from "./file-template/KE_KingdomExpressionsDischarge";
import { KE_IntakeAssessment } from "./file-template/KE_IntakeAssessment";
import { KE_AddictionSeverityIndex } from "./file-template/KE_AddictionSeverityIndex";

import { BRC_ProgressNote } from "./file-template/BRC_ProgressNote";

import { SJC_AddictionSeverityIndex } from "./file-template/SJC_AddictionSeverityIndex";



import { CMC_PsychEvals } from "./file-template/CMC_PsychEvals";
import { CMC_LegalPacket } from "./file-template/CMC_LegalPacket";
import { CMC_SuperBill } from "./file-template/CMC_SuperBill";


// import { PCS_LegalPacket } from "./file-template/PCS_LegalPacket";
import { PCS_DischargeSummary } from "./file-template/PCS_DischargeSummary";
// import { PCS_ProgressNote } from "./file-template/PCS_ProgressNote";
// import { PCS_PsychEvaluation } from "./file-template/PCS_PsychEvaluation";


import { EYPC_DischargeSummary } from "./file-template/EYPC_DischargeSummary";
import { EYPC_BiopsychosocialAssesment } from "./file-template/EYPC_BiopsychosocialAssesment";
import { EYPC_QuarterlyProgressReview } from "./file-template/EYPC_QuarterlyProgressReview";
import { EYPC_ClinicalSupervisionLog } from "./file-template/EYPC_ClinicalSupervisionLog";
import { EYPC_23HourStabilizationSra } from "./file-template/EYPC_23HourStabilizationSra";
import { EYPC_BlankDmasCsSra } from "./file-template/EYPC_BlankDmasCsSra";
import { EYPC_DmaIihSra } from "./file-template/EYPC_DmaIihSra";
import { EYPC_DmaMhsSra } from "./file-template/EYPC_DmaMhsSra";
import { EYPC_DmasCsReferralForm } from "./file-template/EYPC_DmasCsReferralForm";
import { EYPC_DmasCsSra } from "./file-template/EYPC_DmasCsSra";
import { EYPC_DmaSiihSra } from "./file-template/EYPC_DmaSiihSra"; 


import { HFI_AngerManagementAssessment } from "./file-template/HFI_AngerManagementAssessment";
import { HFI_BiopsychosocialEvaluation } from "./file-template/HFI_BiopsychosocialEvaluation";
import { HFI_DiagnosticEvaluation } from "./file-template/HFI_DiagnosticEvaluation";
import { HFI_EapClinicalAssessment } from "./file-template/HFI_EapClinicalAssessment";
import { HFI_EapIntakeInformationForm } from "./file-template/HFI_EapIntakeInformationForm";
import { HFI_Form12 } from "./file-template/HFI_Form12";
import { HFI_Form16 } from "./file-template/HFI_Form16";
import { HFI_InformedConsent } from "./file-template/HFI_InformedConsent";
import { HFI_Form14 } from "./file-template/HFI_Form14";
import { HFI_OrderOfservice } from "./file-template/HFI_OrderOfservice";
import { HFI_PsEmergencyAllergyInformation } from "./file-template/HFI_PsEmergencyAllergyInformation";
import { HFI_PsConsentToServicesForm } from "./file-template/HFI_PsConsentToServicesForm";
import { HFI_PsRightsNotificationForm } from "./file-template/HFI_PsRightsNotificationForm";
import { HFI_Form240 } from "./file-template/HFI_Form240";


import { OTP_DiagnosticAssessment } from "./file-template/OTP_DiagnosticAssessment";
import { OTP_IntakeAssessment } from "./file-template/OTP_IntakeAssessment";
import { OTP_OrderForServices } from "./file-template/OTP_OrderForServices";

import { HMTP_IntakeChecklist } from "./file-template/HMTP_IntakeChecklist";

import { TCC_AdultIntakePacket } from "./file-template/TCC_AdultIntakePacket";
import { TCC_BriefIntakeForm } from "./file-template/TCC_BriefIntakeForm";
import { TCC_DischargePlan } from "./file-template/TCC_DischargePlan";
import { TCC_YouthIntakePacket } from "./file-template/TCC_YouthIntakePacket";

import { TCC_BiopsychosocialAdult } from "./file-template/TCC_BiopsychosocialAdult";
import { TCC_BiopsychosocialChild } from "./file-template/TCC_BiopsychosocialChild";

import { RFS_AdultConcurrentFunctionCriteria } from "./file-template/RFS_AdultConcurrentFunctionCriteria"; 
import { RFS_ChildConcurrentFunctionalCriteria } from "./file-template/RFS_ChildConcurrentFunctionalCriteria"; 
import { RFS_ClientDischargeSummary } from "./file-template/RFS_ClientDischargeSummary"; 
import { RFS_ClinicalAssessment } from "./file-template/RFS_ClinicalAssessment"; 
import { RFS_CrisisPlanSafetyPlan } from "./file-template/RFS_CrisisPlanSafetyPlan"; 
import { RFS_Dla20 } from "./file-template/RFS_Dla20"; 
import { RFS_MonthlySummary } from "./file-template/RFS_MonthlySummary"; 
import { RFS_PrpInitialScreening } from "./file-template/RFS_PrpInitialScreening"; 
import { RFS_PsyEvalTemplateAlleva } from "./file-template/RFS_PsyEvalTemplateAlleva"; 
import { RFS_PsyAlleva } from "./file-template/RFS_PsyAlleva"; 
import { RFS_RiseInitialClientIntakePacket } from "./file-template/RFS_RiseInitialClientIntakePacket"; 
import { RFS_TherapistCollaborationPrpContinuation } from "./file-template/RFS_TherapistCollaborationPrpContinuation"; 

import { TPCS_IddGoalSheet } from "./file-template/TPCS_IddGoalSheet";

import { ECS_YouthAssessment1915 } from "./file-template/ECS_YouthAssessment1915";






export function AddDocumentFileTemplate({
  name,
  controlErrors,
  showValidationError,
  focusEnable,
  selectedPatientList,
  isEdit,
  onGoalsDataStateChange,
  preselctedGoalEdit,
  isViewDoc,
  dxPreselectedData,
  onDxStateChange,
  tpId,
  isDraft,
  draftCommonControlls,
  isFromEditDocs,
  docFieldMappings
  // setHtmlFileValidationError,
}) {



  const arrayOfComponents = {


    ECS_YouthAssessment1915,

    TPCS_IddGoalSheet, 

    RFS_AdultConcurrentFunctionCriteria,
    RFS_ChildConcurrentFunctionalCriteria,
    RFS_ClientDischargeSummary,
    RFS_ClinicalAssessment,
    RFS_CrisisPlanSafetyPlan,
    RFS_Dla20,
    RFS_MonthlySummary,
    RFS_PrpInitialScreening,
    RFS_PsyEvalTemplateAlleva,
    RFS_PsyAlleva,
    RFS_RiseInitialClientIntakePacket,
    RFS_TherapistCollaborationPrpContinuation,

    HMTP_IntakeChecklist,

    TCC_AdultIntakePacket,
    TCC_BriefIntakeForm,
    TCC_DischargePlan,
    TCC_YouthIntakePacket,

    TCC_BiopsychosocialAdult,
    TCC_BiopsychosocialChild,

    OTP_DiagnosticAssessment,
    OTP_IntakeAssessment,
    OTP_OrderForServices,


    // PCS_LegalPacket,
    PCS_DischargeSummary,
    // PCS_ProgressNote,
    // PCS_PsychEvaluation,

    HFI_AngerManagementAssessment,
    HFI_BiopsychosocialEvaluation,
    HFI_DiagnosticEvaluation,
    HFI_EapClinicalAssessment,
    HFI_EapIntakeInformationForm,
    HFI_Form12,
    HFI_Form16,
    HFI_InformedConsent,
    HFI_Form14,
    HFI_OrderOfservice,
    HFI_PsEmergencyAllergyInformation,
    HFI_PsConsentToServicesForm,
    HFI_PsRightsNotificationForm,
    HFI_Form240,

    EYPC_DischargeSummary,
    EYPC_BiopsychosocialAssesment,
    EYPC_QuarterlyProgressReview,
    EYPC_ClinicalSupervisionLog,
    EYPC_23HourStabilizationSra,
    EYPC_BlankDmasCsSra,
    EYPC_DmaIihSra,
    EYPC_DmaMhsSra,
    EYPC_DmasCsReferralForm,
    EYPC_DmasCsSra,
    EYPC_DmaSiihSra,

    CMC_PsychEvals,
    CMC_LegalPacket,
    CMC_SuperBill,

    SJC_AddictionSeverityIndex,

    BRC_ProgressNote,

    KE_SubstanceAbuse,
    KE_KingdomExpressionsDischarge,
    KE_IntakeAssessment,
    KE_AddictionSeverityIndex,

    ACTG_PsychiatricEvaluation,
    ACTG_BlankNcCca,

    WFS_CssrsFullLifetime,
    WFS_NeedsAndStrengths,


    BTCS_ReleaseOfInformation,
    BTCS_CrisisPlan,
    BTCS_ClientIncidentReport,
    BTCS_DischargeSummary,
    BTCS_DiagnosticAssessment,

    KMS_FollowUp,
    KMS_PsychEval,

    FHH_ClinicalSupervisionForm,

    ACS_DischargeSummary,
    ACS_Biopsychosocial,
    ACS_FollowUp,
    ACS_InitialIntakeNote,
    ACS_LifetimeRecentClinical,
    ACS_PediatricCognitivelyImpairedLifetime,
    ACS_SinceLastVisitClinical,
    ACS_SuicideSafetyPlanIntervention,
    ACS_CANS,
    ACS_SupervisionForm,
    ACS_CssrsForm,
    ACS_CtOrderForServices,
    ACS_DocOrderForServices,

    AFHS_InsyncIntakeQuestions,
    AFHS_ClinicalSupervisionParaprofessionals,
    AFHS_ClinicalSupervision,
    AFHS_OrderOfServices,
    AFHS_Phq,
    AFHS_Tsq,
    AFHS_MedicalConsent,
    AFHS_Aims,
    AFHS_AdhdTestAdult,
    AFHS_BorderLinePersonalityDisorder,
    AFHS_OcdTest,
    AFHS_PtsdScreening,
    AFHS_ShortDepressionTest,
    AFHS_SocialAnxietyPhobiaTest,
    AFHS_OnlineBipolarTest,
    AFHS_TelemedicineTelephonicPacket,
    AFHS_IncidentReport,
    AFHS_ContractorTimeOffNotice,
    AFHS_CommunityServicelog,
    AFHS_EmployeeInformation,
    AFHS_EmployeeHandbook,
    AFHS_OpenNoteneticRequest,
    AFHS_TimeOffRequestForm,
    AFHS_GammisAuthReqAmerigroup,
    AFHS_GammisAuthReqCareSource,
    AFHS_GammisAuthReqMedicaid,
    AFHS_GammisAuthReqPeachstate,
    AFHS_GammisAuthReqPrivateOther,
    AFHS_WholeHealthWellnessSurvey, 

    SBM_InitialPsychiatricEvaluation,

    RPBS_FlAnnualPsychosocialHistory,
    RPBS_AdvDirectivesAdult,
    RPBS_FlBpsAnnual,
    RPBS_FlBpsAdult,
    RPBS_MasterServicePlanAdult,
    RPBS_MasterServicePlanChild,
    RPBS_MhtcmAdult,
    RPBS_MhtcmChild,
    RPBS_ServicePlanSixMoChild,
    RPBS_ServicePlanAdult,
    RPBS_ServicePlanAddendumChild,
    RPBS_ServicePlanReviewSixMoAdult,
    RPBS_MasterServicePlan,
    RPBS_AnnualPsychosocialHistory,
    RPBS_ClientCfars,
    RPBS_ClientFarsForms,
    RPBS_ClientTransfer,
    RPBS_DischargeSummary,
    RPBS_GuardianshipCustodyAssessment,
    RPBS_ArPrivacyPracticesNotice,
    RPBS_BpsAdult,
    RPBS_BpsChild,
    RPBS_BpsAnnual,
    RPBS_BreakInService,
    RPBS_BriefStatusExam,
    RPBS_CcbhProviderChoiceLetter,
    RPBS_ClientConsentForm,
    RPBS_ProceduresAcknowledgement,
    RPBS_ClientSignatureConfirmationSheet,
    RPBS_SuicideRiskAssessment,
    RPBS_TherapeuticBehavioralOnsiteServices,
    RPBS_TxPlanReview,
    RPBS_PrivateHealthInformation,
    RPBS_ConsentForFollow,
    RPBS_ConsentForTreatment,
    RPBS_TcmAssessmentChild,
    RPBS_SafetyPlan,
    RPBS_TelemedicineConsent,
    RPBS_AdvDirectivesChild,
    RPBS_Pcp,
    RPBS_SchoolAuthorization,

    NWBH_FarsForm,
    NWBH_AdmissionCriteria,
    NWBH_AdultOutpatient,
    NWBH_BPSAdult,
    NWBH_BPSChild,
    NWBH_BriefBehavioralHealth,
    NWBH_ChildrenCfarsForm,
    NWBH_ClientRegistration,
    NWBH_ConsentForTreatment,
    NWBH_ClientSafetyPlan,
    NWBH_ConsentofRelease,
    NWBH_ContinuedStayCriteria,
    NWBH_Discharge,
    NWBH_flAdvDirectivesAdult,
    NWBH_flMHTCMChild,
    NWBH_flMHTCMAdult,
    NWBH_flAnnualPsychosocialHistory,
    NWBH_flSchoolAuthorization,
    NWBH_FinancialAgreement,
    NWBH_MasterTreatmentPlan,
    NWBH_MasterServicePlan,
    NWBH_NoticePrivacyPractices,
    NWBH_PsychosocialTreatmentPlan,
    NWBH_Pcp,
    NWBH_ServicePlanReview6MoAdult,
    NWBH_InitialTreatmentPlan,
    NWBH_ScreeningQuestionnaire,
    NWBH_SubstanceAbuseAdmission,
    NWBH_SubstanceAbuseDischarge,
    NWBH_SlidingFeeScale,
    NWBH_OutcomeMeasures,


    SLBC_Pcp,

    PBS_AdultAssessment,
    PBS_ChildAdolescentDiagnostic,
    PBS_ChildAdolescentAssessment,

    ACTS_AmethystTreatmentConsent,
    ACTS_BlankSed,
    ACTS_CalocusScoringSheet,
    ACTS_CaregiverScreening,
    ACTS_Cats,
    ACTS_Cft,
    ACTS_ChildBehaviorChecklist,
    ACTS_ClientAcknowledgementsAdditionalConsents,
    ACTS_ClinicalAssessmentSignaturePage,
    ACTS_ComprehensiveClinicalAssessment,
    ACTS_ConsentMstServices,
    ACTS_DataSheet,
    ACTS_DjjConsentForm,
    ACTS_FinancialResponsibilityAgreementAuthorization,
    ACTS_InsuranceConsentFormReleaseInformation,
    ACTS_IntakePacket,
    ACTS_JJBHConsentFormReleaseInformation,
    ACTS_LocoParents,
    ACTS_MSTCaseSummary,
    ACTS_MSTTreatmentPlanSignaturePage,
    ACTS_Mass,
    ACTS_MedicaidDirectTransition,
    ACTS_MstGenogram,
    ACTS_MstPrescreening,
    ACTS_MstProgram,
    ACTS_MultisystemicTherapyPreScreening,
    ACTS_NcSedCheckList,
    ACTS_OptDischargeSummary,
    ACTS_OptProgram,
    ACTS_OptTreatmentPlanSignaturePage,
    ACTS_OptTxPlan,
    ACTS_OptTxPlanSig,
    ACTS_PersonCenteredProfile,
    ACTS_PrimaryCareConsentFormReleaseInformation,
    ACTS_SchoolConsentForm,
    ACTS_SpecimenCollectionDrugTestingConsentForm,
    ACTS_SupervisionSign,
    ACTS_WeeklyTelephoneConsultation,
    ACTS_YouthCatsScreening,
    ACTS_BlankPersonCenteredPlan,

    RRTS_Cans,
    RRTS_RiskAndSubstanceAssessment,
    RRTS_RecipientSafetyPlan,
    RRTS_IndividualizedCrisisPlan,
    RRTS_BhaHumana,
    RRTS_BhaChild,
    RRTS_BhaAdult,
    RRTS_OutpatientTreatmentRequest,
    RRTS_monthlyStaffForm,
    RRTS_ColumbiaRatingScaleandAssessment,
    RRTS_DischargeSummary,
    RRTS_HealthWellnessQuestionnaire,
    RRTS_AuthRequestHealthyBlueOPForm,
    RRTS_AuthRequestAmerihealthAdult,
    RRTS_AuthRequestAmerihealthChildOTRForm,
    RRTS_AetnaPriorAuthrorization,

    LBS_AdultIntake,
    LBS_BriefBipolardisorderSymptomScale,
    LBS_MedManagementPsychiatricProgressNote,
    LBS_PsychiatricEvaluation,
    LBS_SafetyPlan,
    LBS_ScreenforChildAnxietyRelatedDisordersScaredChild,
    LBS_SnapAssessmentAdult,
    LBS_SnapAssessmentChildrenAdolescent,
    LBS_TreatmentPlanUpdateQuestionnaire,
    LBS_YouthIntake,
    LBS_CuttingSymptomMeasureAdult,
    LBS_CuttingSymptomMeasureChild,
    LBS_Gad,
    LBS_AngerChild,
    LBS_DepressionChild,



    NHBC_ConsentForm,
    NHBC_BriefPsychosocialAssessment,
    NHBC_ClientHandbook,
    NHBC_CoreOrderForServices,
    NHBC_CssrsScreenerClinical,
    NHBC_CssrsScreenerLifetimeRecent,
    NHBC_CssrsPediaCogniImpaired,
    NHBC_DiagnosticAssessment,
    NHBC_DiagnosticOrderForServices,
    NHBC_DischargeSummary,
    NHBC_DomesticViolenceAssessment,
    NHBC_BlankIntakeForm,
    NHBC_Mdt,
    NHBC_NursingFollowUp,
    NHBC_NursingAssessmentInitial,

    NHBC_PatientPortalConsentForm,
    NHBC_PsychEvalFollowUp,
    NHBC_PsychIntake,
    NHBC_PsychologicalTesingOrderForServices,
    NHBC_PsychosocialAssessment,
    NHBC_ReleaseOfInformationForm,
    NHBC_SafetyPlan,
    NHBC_SubstanceAbuseAssessment,
    NHBC_TraumaAssessment,

    TCDC_HealthAssessmentAdult,
    TCDC_HealthAssessmentYouth,

    GBHCT_BpsDocument,

    CBS_FaxCoverSheetAethna,
    CBS_FaxCoverSheetAmerihealth,
    CBS_FaxCoverSheetHealthyBlue,
    CBS_FaxCoverSheetLAHC,
    CBS_FaxCoverSheetUnitedHealthcare,
    CBS_UnitedHealthcareAuthForm,
    CBS_PriorAuthorizationFormAethna,
    CBS_MentalHealthRehabilitationAdult,
    CBS_BehavHealthOutTreatRequest,
    CBS_AuthReferralRequestFormHumana,
    CBS_AdultAssessment1915i,
    CBS_InitialPsychiatricAssessment,
    CBS_LhccOtr,
    CBS_LocusScoreSheet,
    CBS_NpRequestedForm,

    C3_BiopsychosocialAssessment,
    C3_DischargeSummary,
    C3_AssessmentAddendum,
    C3_CollaborativeTeamMeeting,
    C3_PersonCenteredPlan,
    C3_Dla,

    AA_BhaChild,
    AA_BhaAdult,

    CBHS_RehabFormAdult,
    CBHS_RehabFormChild,
    CBHS_PriorAuthorizationFormAethna,
    CBHS_BehavHealthOutTreatRequest,
    CBHS_AuthReferralRequestFormHumana,

    MMBHC_MentalHealthAssessment,
    MMBHC_BehavioralHealthAssessment,
    MMBHC_RecipientDataPacket,

    BFCS_ClinicalSupervision,
    BFCS_Locus,
    BFCS_Calocus,
    BFCS_PsychiatricAssessment,
    BFCS_YouthAssessment1915,
    BFCS_CrisisSafetyPlan,
    BFCS_DischargeSummary,
    BFCS_InitialCaseSummary,
    BFCS_MstDischargeSummary,
    BFCS_ProgressSummary2023,
    BFCS_TransitionPlan,
    BFCS_AdultAssessment1915,
    BFCS_FreedomOfChoice,
    BFCS_RehabMemberChoice,
    BFCS_WeeklyCaseSummary,
    BFCS_CrisisIntakeAssessment,

    LHH_WeeklyProgressNote,
    LHH_IddServiceNote,
    LHH_ConsumerReferralForm,
    LHH_InitialAssessment,
    LHH_OutPatientTreatmentRequest,
    LHH_SelfAdministeredMedObservation,
    LHH_IncidentReport,
    LHH_ServiceTerminationChangeSummary,
    LHH_ProviderDischargeSummary,
    LHH_DLAFunctionalAssessment,

    LHH_24HrCrisisAndEmergencyAfterHr,
    LHH_AbuseAndNeglect,
    LHH_AcknowledgementFreedomChoice,
    LHH_AcknowledgementGrievanceProcedures,
    LHH_BehaviorDataSheet,
    LHH_ChiefComplaintReasonEncounter,
    LHH_ClientEntryForm,
    LHH_ClientRights,
    LHH_ConfidentialityComplianceAgrmt,
    LHH_ConsentReceiveServices,
    LHH_ConsentReleaseInfo,
    LHH_DocOfHealthcareProviderVisits,
    LHH_ErPreparednessPlanAndAcknowledge,
    LHH_FoodAllergiesForm,
    LHH_IddActivitySuppPlan,
    LHH_IdDdWaiverBehaviorSuppPlan,
    LHH_IdDdWaiverBhSupportQuarterlyRevRep,
    LHH_IdDdWaiverFunctionalBhAss,
    LHH_IdDdWaiverJustificationForBhSuppSvs,
    LHH_IdDdWaiverReqForAdditionalBhSuppSvs,
    LHH_IndividualSvsPlan,
    LHH_LegalGuardianshipAssignBenefits,
    LHH_LunchConsumptionChart,
    LHH_MealChart,
    LHH_MedicalExamination,
    LHH_MedicationEmerContactInfo,
    LHH_PeriodicStaffingRevOfIsp,
    LHH_PermissionToTransport,
    LHH_PetPolicy,
    LHH_PreliminaryPersonCenteredRecoveryPlan,
    LHH_PsychiatricAdvanceDirective,
    LHH_PsychiatricAssessment,
    LHH_PsychosocialAssessment,
    LHH_QuarterlyHomeVisits,
    LHH_RecoverySuppPlan2023,
    LHH_RightsIndividualsReceivingSvs,
    LHH_SymptomScreeningChecklist,
    LHH_TelephoneVisitationAgreement,
    LHH_TerminationChangeSummary,
    LHH_TraumaHistory,
    LHH_WaiverOfLiability,
    LHH_SelfAdminMedObservationLog,
    LHH_DailyLivingActivities,
    LHH_InitialAssessmentV2,




    OABS_AdultSubstanceAssessment,
    OABS_Asam,
    OABS_ChildSubstanceAssessment,
    OABS_PsychiatricEvaluation,
    OABS_BhaChild,
    OABS_BhaAdult,
    OABS_AnnualPsychiatric,

    MC_ComprehensiveClinicalAssessment,
    MC_IntakeAssessment,

    MRRC_PhysicalHealthStandard,
    MRRC_MentalHealthRehabilitationAdult,
    MRRC_BehavioralHealthOutpatient,
    MRRC_BehavioralHealthCommunity,
    MRRC_OutpatientTreatmentRequest,
    MRRC_MemberChoiceForm,

    RHCA_IntakePacket,
    RHCA_ReleaseOfInformation,
    RHCA_SafetyPlan,
    RHCA_OrderForServices,
    RHCA_ChildAndAdolescentBha,
    RHCA_ANSA,


    JCS_BhaChild,
    JCS_BhaAdult,

    PD_DischargeSummary,
    PD_BehavioralHealthAssessment,
    PD_AnnualPacket,
    PD_IntakePacket,

    RNFI_ClientRights,
    RNFI_ConsentToTreatment,
    RNFI_Hippa,
    RNFI_LabConsent,
    RNFI_LimitsToLiability,
    RNFI_PersonalHxForm,
    RNFI_PlanSignaturePage,
    RNFI_Roi,
    RNFI_TransportationWaiver,
    RNFI_Assessment,
    RNFI_BiopsychosocialAdult,
    RNFI_BiopsychosocialChild,
    RNFI_CssrsLifetimeRecent,
    RNFI_CssrsLifetimeRecentYoungChild,
    RNFI_DiagnosticAx,
    RNFI_DischargeSummary,
    RNFI_CmoAuthorizationRequestForm,

    FYD_ChildAssessment,

    LCS_YouthAssessment1915,
    LCS_InitialCaseSummary,
    LCS_AdultAssessment1915,
    LCS_CrisisSafetyPlan,
    LCS_FreedomOfChoice,
    LCS_RehabMemberChoice,
    LCS_ProgressSummary2023,
    LCS_WeeklyCaseSummary,
    LCS_MstDischargeSummary,
    LCS_DischargeSummary,
    LCS_TransitionPlan,
    LCS_PsychiatricAssessment,
    LCS_Calocus,
    LCS_Locus,
    LCS_CrisisIntakeAssessment,
    LCS_IndividualClinicalSupervision,


    EDU_TCMNeedsAssessment,
    EDU_NoteRiskAssessment,
    EDU_MonthlyClinicalSummary,
    EDU_HealthReassessment,
    EDU_Bps,
    EDU_Biospsychosocial,
    EDU_UniversalNote,
    EDU_CANS,

    SSS_MentalHealthAdult,
    SSS_MentalHealthChild,
    SSS_ProgressSummary,
    SSS_PsychiatricEvaluation,
    SSS_PsychiatricFollowUp,
    SSS_TreatmentPlanReview,

    FWC_BhaAdult,
    FWC_BhaChild,
    FWC_ClientLegalForm,
    FWC_ServicePlanDevelopment,

    JHC_AdolescentIntakePacket,
    JHC_AdultIntakePacket,
    JHC_AdultAcknowledementOfClientHandbook,
    JHC_AdultClientAbuse,
    JHC_AdultClientFreedomChoice,
    JHC_AdultClientGrievances,
    JHC_AdultClientOrientation,
    JHC_AdultClientRightsAndResponsbilities,
    JHC_AdultCrisisMangeGuidelines,
    JHC_AdultDeterminationProcess,
    JHC_AdultEmergencyPreparednessQuestionnaire,
    JHC_AdultHippaAcknowledement,
    JHC_AdultHippaAuthForm,
    JHC_AdultInformedConsentforTreatment,
    JHC_AdultPhq,
    JHC_AdultPsychiatricAdvanceDirective,
    JHC_AdultTeleMedicineService,
    JHC_InSchoolSetting,


    GFIT_AmazingPediatricsReferralForm,
    GFIT_AuthorizationConsent,
    GFIT_FollowUpNursingAssessment,
    GFIT_InitialNursingAssessment,
    GFIT_LaboratoryRequestForm,
    GFIT_PsychiatricEM,
    GFIT_PsychiatricEvaluationTemplate,
    GFIT_PsychotropicMedConsent,
    GFIT_AdultAdhd,
    GFIT_AdultServiceOrder,
    GFIT_ChildAdhd,
    GFIT_CssrsForm,
    GFIT_VerifiedDiagnosisForm,
    GFIT_AdultPtsdForm,
    GFIT_SafetyPlan,

    ATC_AngerAdultAssessment,
    ATC_AnxietyAdult,
    ATC_BehaviorAndSymptomRatingScale,
    ATC_CommunityResourceLinkage,
    ATC_FollowUpProgressNote,
    ATC_PatientConsentForm,
    ATC_InitialDiagnosticProgressNote,
    ATC_BpsAdult,
    ATC_BpsChild,
    ATC_CssrsScreenerClinical,
    ATC_MonthlyServiceSummary,
    ATC_NurseAx,
    ATC_NurseFu,
    ATC_ANSA,
    ATC_CANS,
    ATC_CssrsScreenerLifetimeRecent,
    ATC_DischargeSummary,
    ATC_OrderOfServices,
    ATC_Wellcare,
    ATC_SubstanceAbuseChild,
    ATC_SubstanceAbuseAdult,
    ATC_SomaticSymptomPatient,

    CS_InterviewQuestions,
    CS_ReleaseOfInformation,
    CS_Disclosure,
    CS_AdditionalInformation,
    CS_ProgressReport,
    CS_JobTrackingSheet,

    AJC_AttendancePolicyConsent,
    AJC_AuthorizationReleaseInformation,
    AJC_ClientGrievances,
    AJC_ClientRightsResponsibilities,
    AJC_ConsentForServices,
    AJC_DemographicForm,
    AJC_NoticeOfPrivacyPractice,
    AJC_SrcTransportationServices,
    AJC_IntakeForm,
    AJC_ChildIntakeQuestionnaire,

    LSS_AAsamAssessment,
    LSS_DiagnosticEvaluation,
    LSS_CaAsamAssessment,
    LSS_SudItp,
    LSS_IntegratedBehavioralHealth,
    LSS_IndividualTreatmentPlan,
    LSS_OrderOfServices,
    LSS_TerminationLetter,
    LSS_DischargeSummary,
    LSS_IndividualStatusReport,
    LSS_ClientDischargeSummary,
    LSS_StatementOfProviderChoice,
    LSS_ConsumerRights,
    LSS_PatientFinancialResponsibility,
    LSS_AuthorizationToRelease,
    LSS_ConsentForTreatment,
    LSS_PhotoReleaseForm,
    LSS_ConsentToTeleMentalHealth,
    LSS_TransportationPermissionSlip,

    NP_DischargeSummary,
    NP_MonthlySummary,
    NP_DiagnosticAssessment,
    NP_AdultBha,
    NP_SubstanceAbuseAssesment,
    NP_UnitReq,
    NP_NursingAssessment,
    NP_CaAssessment,
    NP_PsychMed,

    ROC_IntakeReferralForm,
    ROC_MemberOrientationForm,
    ROC_RecipientRightsResponsibilities,
    ROC_ReleaseOfInformation,
    ROC_TeleBehavioralHealthInformedConsent,
    ROC_EmergencyMedicalTreatment,
    ROC_ClientConfidentiality,
    ROC_AuthorizationReleaseOfInformation,
    ROC_GrievanceProcedure,
    ROC_PermissionToBill,
    ROC_ClientWaiver,
    ROC_ProviderSelection,
    ROC_NoticeOfPrivacyPractices,
    ROC_TreatmentPlanConsent,
    ROC_DiagnosticAssessment,
    ROC_MemberSatisfactionSurvey,
    ROC_ProfessionalDevelopment,
    ROC_SupervisionForm,
    ROC_CriticalIncidentReportForm,

    ROCLA_BhaAdult,
    ROCLA_BhaChild,

    NBT_AdultIntake,
    NBT_ChildIntake,
    NBT_AngerAdultAssessment,
    NBT_AnxietyAdult,
    NBT_6MonthReassessment,
    NBT_ClientReport,
    NBT_CrisisPlan,
    NBT_CrossCuttingSymptomMeasure,
    NBT_DiagnosticExam,
    NBT_DepressionAdult,
    NBT_DischargeSummary,
    NBT_ParentGuardian,
    NBT_ManiaAdult,
    NBT_NurseAssessment,
    NBT_OrderOfServices,
    NBT_SubstanceUseAdult,
    NBT_ThoughtsAdult,
    NBT_PsychFollowUp,
    NBT_PsychDiagnosticExam,
    NBT_SomaticSymptomAdultPatient,
    NBT_BiopsychosocialChild,
    NBT_BiopsychosocialAdult,
    NBT_Assessment,
    NBT_AssessmentV2,
    NBT_SchoolConsultationForm,
    NBT_CssrsScreenerLifetime,
    NBT_CssrsScreenerFollowUp,
    NBT_ReleaseOfInformation,
    NBT_SchoolConsentForm,

    GHP_AIMS_V2,
    GHP_AIMS,
    GHP_ANSA,
    GHP_CALOCUS_V1,
    GHP_CALOCUS,
    GHP_CANS,
    GHP_ClientIntroductionLetter,
    GHP_COREOrderForServices,
    GHP_COREOrderForServicesMD,
    GHP_CourtReport,
    GHP_DischargeSummary,
    GHP_DrugMonitoringForm,
    GHP_EarlyTermination,
    GHP_IFIBPS,
    GHP_IFIDischargeSummary,
    GHP_IFIOrderForServices,
    GHP_IFIOrderForServicesMedical,
    GHP_IFISafetyPlan,
    GHP_IndividualStatusReport,
    GHP_InformedConsentforMedication,
    GHP_ISR,
    GHP_MARS,
    GHP_MedicationConsentChild,
    GHP_MedicationInformedConsentForm,
    GHP_NewLocus,
    GHP_PhysicianFollowUp,
    GHP_PsychiatricEvaluation,
    GHP_QuarterlyBehaviour,
    GHP_ChildAdultAssessment,
    GHP_BlankOrderForServices,
    GHP_ChildAdolescentNeedStrengths,
    GHP_AdultAssessment,
    GHP_CriticalIncidentReport,
    GHP_NursingAssessment,
    GHP_CaBiopsychosocialTreatmentPlan,
    GHP_AdultBiopsychosocialTreatmentPlan,
    GHP_OldVersionNursingAssessment,
    GHP_NursingFollowUpTemplate,
    GHP_DiagnosticAssessment,
    GHP_IfiTreatmentPlan,


    SampleFileTemplate,
    TemplateFile2,

    GENERAL_MonthlyStaffForm,
    GENERAL_DischargeSummary,
    GENERAL_HealthReassessment,
    GENERAL_PsychiatricAssessment,
    GENERAL_NursingAssessment,
    GENERAL_DiagnosticAssessment,
    GENERAL_InformedConsentforMedication,
    GENERAL_MedicationConsentChild,
    GENERAL_MedicationInformedConsentForm,
    GENERAL_TeleBehavioralHealthInformedConsent,
    GENERAL_TreatmentPlanConsent,
    GENERAL_ConsentForTreatment,
    GENERAL_ConsentToTeleMentalHealth,
    GENERAL_AdultIntake,
    GENERAL_ChildIntake,
    GENERAL_IntakeReferralForm,
    GENERAL_CssrsAssessment,
    GENERAL_CANS,
    GENERAL_SNAP,
    GENERAL_ANSA,
    GENERAL_AIMS,
    GENERAL_OrderOfServices,
    GENERAL_AuthorizationToRelease,
    GENERAL_BehavioralHealthAssessment,
    GENERAL_MedicaidAssessment,
    GENERAL_LOCUS,
    GENERAL_CALOCUS,
    GENERAL_Bps,
    GENERAL_BiopsychosocialAdult,
    GENERAL_BiopsychosocialChild,
    GENERAL_ReferralAndIntake,
    GENERAL_FamilyNeedsAssessment,
    GENERAL_MigrantInformationForm,
    GENERAL_ServicePlan,
    GENERAL_ServicePlanConsent,
    GENERAL_FollowUpForm,
    GENERAL_FollowUpDocumentation,
    GENERAL_ProgressNotes,
    GENERAL_ReferralForm,
    GENERAL_CaseClosureForm,
    GENERAL_CaseTransfer,
    GENERAL_SignificantProviderChanges,
    GENERAL_RecordOfBilledServices,
    GENERAL_EngAuthorizationToDPHI,
    GENERAL_SpanishAuthorizationToDPHI,
    GENERAL_ProviderSystemsReview,
    GENERAL_RecordReviewToolForProviders,
    GENERAL_PhysicalHealthStandard,
    GENERAL_MentalHealthRehabilitationAdult,
    GENERAL_BehavioralHealthOutpatient,
    GENERAL_BehavioralHealthCommunity,
    GENERAL_OutpatientTreatmentRequest,
    GENERAL_Asam,
    GENERAL_PCP,
    GENERAL_PIE,

    LaGeneral_AdultAssessment1915,
    LaGeneral_PsychiatricAssessment,
    LaGeneral_YouthAssessment1915,
    LaGeneral_SafetyPlan,
    LaGeneral_StrengthAndNeeds,
    LaGeneral_HealthAndWellnessQuestionnaire,
    LaGeneral_AdultMentalHealthRehabilitationTreatmentRequestForm,
    LaGeneral_AetnaBetterHealthOfLouisiana,
    LaGeneral_AmerigroupOutpatientTreatmentRequestForm,
    LaGeneral_ChildAndAdolescentMentalHealthRehabilitationTreatmentRequestForm,
    LaGeneral_Asam,
    LaGeneral_BehaviorModificationPlan,
    LaGeneral_IBHA1915c,
    LaGeneral_CalocusScoresheet,
    LaGeneral_Cans,
    LaGeneral_CommunityBasedServicesAuthorizationRequestForm,
    LaGeneral_CrisisPlan,
    LaGeneral_InitialCrisisIntervention,
    LaGeneral_OutpatientTreatmentRequestForm,
    LaGeneral_LOCUS,
    LaGeneral_LocusScoringSheet,
    LaGeneral_OutpatientTreatmentRequest,
    LaGeneral_RequestForm,
    LaGeneral_ProgressNote,
    LaGeneral_RehabilitationMemberChoiceForm,
    LaGeneral_TeleHealthConsentForm,
    LaGeneral_WellnessAssessmentYouth,
    LaGeneral_AHCHealthAndWellnessQuestionnaire,
    LaGeneral_BHBHA,
    LaGeneral_WellnessAssessmentAdult,

    TxGeneral_CANS,
    TxGeneral_CansChild6,
    TxGeneral_CansChild3,
    TxGeneral_ANSA,

    NcGeneral_ComprehensiveClinicalAssessment,
    NcGeneral_CCA,

    GaGeneral_BiopsychosocialAdult,
    GaGeneral_BiopsychosocialChild,

    AI_BIRP,
    
    GENERAL_StaffPlanDocument


  };

  const itemsRef = useRef(null);
  const [errorList, setErrorList] = useState([]);
  const ComponentToRender = arrayOfComponents[name];
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFromEditDocs && docFieldMappings) {
      dispatch(loaderAction(true))
      setTimeout(() => {
        onShowFileTempFields(docFieldMappings, "", false);
        dispatch(loaderAction(false))
      }, 2000)

    }
  }, [itemsRef])

  useEffect(() => {
    const handleChange = (_) => {
      // setHtmlFileValidationError()
    };

    const formEl = document.getElementById(name);
    formEl?.addEventListener("change", handleChange);

    return () => {
      formEl?.removeEventListener("change", handleChange);
    };
  }, []);

  useEffect(() => {
    let errorList =
      !showValidationError || !controlErrors || controlErrors.length < 1
        ? []
        : controlErrors;
    setErrorList(errorList);
  }, [showValidationError, controlErrors]);

  useEffect(() => {
    if (focusEnable && errorList && errorList.length > 0) {
      const uniqueIndex = errorList[0].id;
      if (
        itemsRef.current &&
        itemsRef.current[uniqueIndex] &&
        itemsRef.current[uniqueIndex].focus
      ) {
        itemsRef.current[uniqueIndex].focus();
      }
    }
  }, [errorList, focusEnable]);

  function showErrorFor(id) {
    if (!errorList) return <></>;
    const error = errorList.find((error) => error.id === id);
    if (!error) return <></>;
    return <Error>{error.msg}</Error>;
  }

  return ComponentToRender ? (


    <ComponentToRender
      itemsRef={itemsRef}
      showErrorFor={showErrorFor}
      selectedPatientList={selectedPatientList}
      isEdit={isEdit}
      onGoalsDataStateChange={onGoalsDataStateChange}
      preselctedGoalEdit={preselctedGoalEdit}
      isViewDoc={isViewDoc}
      dxPreselectedData={dxPreselectedData}
      onDxStateChange={onDxStateChange}
      tpId={tpId}
      isDraft={isDraft}
      draftCommonControlls={draftCommonControlls}
    />

  ) : (
    <></>
  );
}